// import React, { useEffect } from 'react';
// import { create } from 'zustand';
// import { useNavigate } from 'react-router-dom';
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, AreaChart, Area, PieChart, Pie, Cell } from 'recharts';
// import { CSSTransition, TransitionGroup } from 'react-transition-group';
// import 'bootstrap/dist/css/bootstrap.min.css';

// // Color palette
// const colors = {
//   primary: '#66a1c2',
//   secondary: '#c266a1',
//   success: '#66c26a',
//   danger: '#c26666',
//   warning: '#c2b866',
//   info: '#66c2c2',
//   light: '#f8f9fa',
//   dark: '#343a40',
//   accent: '#ee373b',
//   pastel1: '#ffb3ba',
//   pastel2: '#ffdfba',
//   pastel3: '#ffffba',
//   pastel4: '#baffc9',
//   pastel5: '#bae1ff',
// };

// // Helper function to format date
// const formatDateTime = (dateString) => {
//   try {
//     const date = new Date(dateString);
//     return date.toLocaleString('en-US', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: false
//     });
//   } catch (e) {
//     return dateString;
//   }
// };

// // Simplified date format function
// const formatDate = (dateString) => {
//   const date = new Date(dateString);
//   return date.toLocaleDateString('en-US', {
//     day: '2-digit',
//     month: 'short',
//     year: 'numeric'
//   });
// };

// // Zustand store setup
// const useDashboardStore = create((set) => ({
//   // Initial state
//   kpis: null,
//   events: [],
//   regionData: [],
//   monthlyTrends: [],
//   customerUploads: [],
//   filters: {
//     region: 'all',
//     zone: 'all',
//     dateRange: {
//       start: '',
//       end: ''
//     },
//     eventType: 'all'
//   },
//   selectedEvent: null,
//   isEventModalOpen: false,
//   loading: false,
//   // Actions
//   setKPIs: (kpis) => set({ kpis }),
//   setEvents: (events) => set({ events }),
//   setRegionData: (regionData) => set({ regionData }),
//   setMonthlyTrends: (monthlyTrends) => set({ monthlyTrends }),
//   setCustomerUploads: (customerUploads) => set({ customerUploads }),
//   setFilters: (newFilters) => set((state) => ({
//     filters: { ...state.filters, ...newFilters }
//   })),
//   setSelectedEvent: (selectedEvent) => set({ selectedEvent }),
//   setEventModalOpen: (isEventModalOpen) => set({ isEventModalOpen }),
//   setLoading: (loading) => set({ loading })
// }));

// // Mock data
// const mockKPIs = {
//   totalLoanDisbursed: 12500000.50,
//   totalWinningBids: 140,
//   totalEvents: 35,
//   totalCarsMapped: 300,
//   totalUsersMapped: 220,
//   loanSuccessRate: 72.5,
//   totalCustomersUploaded: 410
// };

// const mockEvents = [
//   {
//     eventId: 101,
//     eventTitle: "Mumbai Premium Auction",
//     location: "Mumbai",
//     zone: "Zone A",
//     region: "West",
//     startDate: "2025-01-15T09:00:00Z",
//     endDate: "2025-01-15T17:00:00Z",
//     totalCars: 28,
//     totalUsers: 25,
//     totalWinningBids: 22,
//     loanDisbursed: 680000,
//     loanSuccessRate: 78.6,
//     status: 'past'
//   },
//   {
//     eventId: 102,
//     eventTitle: "Delhi Luxury Cars",
//     location: "Delhi",
//     zone: "Zone B",
//     region: "North",
//     startDate: "2025-01-20T10:00:00Z",
//     endDate: "2025-01-20T18:00:00Z",
//     totalCars: 35,
//     totalUsers: 30,
//     totalWinningBids: 28,
//     loanDisbursed: 950000,
//     loanSuccessRate: 80.0,
//     status: 'past'
//   },
//   {
//     eventId: 103,
//     eventTitle: "Chennai Super Auction",
//     location: "Chennai",
//     zone: "Zone C",
//     region: "South",
//     startDate: "2025-02-05T09:30:00Z",
//     endDate: "2025-02-05T16:30:00Z",
//     totalCars: 42,
//     totalUsers: 38,
//     totalWinningBids: 35,
//     loanDisbursed: 1200000,
//     loanSuccessRate: 83.3,
//     status: 'past'
//   },
//   {
//     eventId: 104,
//     eventTitle: "Bangalore Tech City Auction",
//     location: "Bangalore",
//     zone: "Zone D",
//     region: "South",
//     startDate: "2025-02-15T08:00:00Z",
//     endDate: "2025-02-15T20:00:00Z",
//     totalCars: 50,
//     totalUsers: 45,
//     totalWinningBids: 38,
//     loanDisbursed: 1450000,
//     loanSuccessRate: 76.0,
//     status: 'live'
//   },
//   {
//     eventId: 105,
//     eventTitle: "Kolkata Heritage Auction",
//     location: "Kolkata",
//     zone: "Zone E",
//     region: "East",
//     startDate: "2025-03-01T10:00:00Z",
//     endDate: "2025-03-01T18:00:00Z",
//     totalCars: 30,
//     totalUsers: 28,
//     totalWinningBids: 0,
//     loanDisbursed: 0,
//     loanSuccessRate: 0,
//     status: 'upcoming'
//   },
//   {
//     eventId: 106,
//     eventTitle: "Pune Innovation Drive",
//     location: "Pune",
//     zone: "Zone F",
//     region: "West",
//     startDate: "2025-03-10T11:00:00Z",
//     endDate: "2025-03-10T19:00:00Z",
//     totalCars: 25,
//     totalUsers: 22,
//     totalWinningBids: 0,
//     loanDisbursed: 0,
//     loanSuccessRate: 0,
//     status: 'upcoming'
//   }
// ];

// const mockRegionData = [
//   {
//     region: "North",
//     zone: "Zone B",
//     totalBids: 200,
//     winningBids: 150,
//     loanDisbursed: 1200000,
//     successRate: 75.0
//   },
//   {
//     region: "South",
//     zone: "Zone C",
//     totalBids: 180,
//     winningBids: 145,
//     loanDisbursed: 1450000,
//     successRate: 80.6
//   },
//   {
//     region: "West",
//     zone: "Zone A",
//     totalBids: 160,
//     winningBids: 120,
//     loanDisbursed: 980000,
//     successRate: 75.0
//   },
//   {
//     region: "East",
//     zone: "Zone E",
//     totalBids: 120,
//     winningBids: 85,
//     loanDisbursed: 750000,
//     successRate: 70.8
//   }
// ];

// const mockMonthlyTrends = [
//   { month: "Oct 2024", loanDisbursed: 750000 },
//   { month: "Nov 2024", loanDisbursed: 820000 },
//   { month: "Dec 2024", loanDisbursed: 950000 },
//   { month: "Jan 2025", loanDisbursed: 1100000 },
//   { month: "Feb 2025", loanDisbursed: 1350000 },
//   { month: "Mar 2025", loanDisbursed: 850000 }
// ];

// const mockCustomerUploads = [
//   {
//     region: "North",
//     zone: "Zone B",
//     totalUploaded: 120,
//     totalAllowed: 95
//   },
//   {
//     region: "South",
//     zone: "Zone C",
//     totalUploaded: 105,
//     totalAllowed: 88
//   },
//   {
//     region: "West",
//     zone: "Zone A",
//     totalUploaded: 98,
//     totalAllowed: 85
//   },
//   {
//     region: "East",
//     zone: "Zone E",
//     totalUploaded: 87,
//     totalAllowed: 72
//   }
// ];

// // Enhanced Nested Pie Chart Component with improved layout
// const ZoneRegionNestedPieChart = () => {
//   const generateEventData = () => {
//     const zones = ['South', 'West', 'North', 'East', 'Central'];
//     const regions = ['Region1', 'Region2', 'Region3', 'Region4'];
//     const data = {};
//     let totalEvents = 0;
//     zones.forEach(zone => {
//       data[zone] = {};
//       let zoneTotal = 0;
//       regions.forEach(region => {
//         const eventCount = Math.floor(Math.random() * 66) + 15;
//         data[zone][region] = eventCount;
//         zoneTotal += eventCount;
//         totalEvents += eventCount;
//       });
//       data[zone].total = zoneTotal;
//     });
//     return { data, totalEvents };
//   };

//   const { data: eventData, totalEvents } = generateEventData();
//   const zoneColors = {
//     'South': colors.pastel1,
//     'West': colors.pastel2,
//     'North': colors.pastel3,
//     'East': colors.pastel4,
//     'Central': colors.pastel5
//   };

//   const getRegionColor = (zoneName, regionIndex) => {
//     const baseColor = zoneColors[zoneName];
//     const opacity = 0.3 + (regionIndex * 0.15);
//     return baseColor + Math.floor(opacity * 255).toString(16).padStart(2, '0');
//   };

//   const pieData = [];
//   Object.keys(eventData).forEach((zone, zoneIndex) => {
//     const zoneTotal = eventData[zone].total;
//     if (zoneIndex > 0) {
//       pieData.push({
//         name: `separator-${zoneIndex}`,
//         value: totalEvents * 0.002,
//         isZone: false,
//         isSeparator: true,
//         zone: zone,
//         color: '#ffffff'
//       });
//     }
//     Object.keys(eventData[zone])
//       .filter(key => key !== 'total')
//       .forEach((region, regionIndex) => {
//         const regionValue = eventData[zone][region];
//         const regionPercentage = (regionValue / totalEvents) * 100;
//         pieData.push({
//           name: `${zone} - ${region}`,
//           value: regionValue,
//           isZone: false,
//           isSeparator: false,
//           zone: zone,
//           region: region,
//           color: getRegionColor(zone, regionIndex),
//           zonePercentage: ((zoneTotal / totalEvents) * 100).toFixed(1),
//           regionPercentage: regionPercentage.toFixed(1),
//           regionOfZonePercentage: ((regionValue / zoneTotal) * 100).toFixed(1)
//         });
//       });
//   });

//   const CustomTooltip = ({ active, payload }) => {
//     if (active && payload && payload.length) {
//       const data = payload[0].payload;
//       if (data.isSeparator) return null;
//       return (
//         <div style={{
//           backgroundColor: 'white',
//           padding: '1rem',
//           border: '1px solid #ddd',
//           borderRadius: '8px',
//           boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
//         }}>
//           <p style={{ fontWeight: 600, marginBottom: '0.5rem', fontSize: '1rem', color: colors.dark }}>
//             {data.zone}
//           </p>
//           <p style={{ fontSize: '0.875rem', color: colors.dark, marginBottom: '0.5rem' }}>
//             {data.region}
//           </p>
//           <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>
//             <span style={{ fontWeight: 500 }}>Events:</span> {data.value.toLocaleString()}
//           </p>
//           <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>
//             <span style={{ fontWeight: 500 }}>% of Total:</span> {data.regionPercentage}%
//           </p>
//           <p style={{ fontSize: '0.875rem', marginBottom: 0 }}>
//             <span style={{ fontWeight: 500 }}>% of Zone:</span> {data.regionOfZonePercentage}%
//           </p>
//         </div>
//       );
//     }
//     return null;
//   };

//   const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value, payload }) => {
//     if (payload.isSeparator) return null;
//     const RADIAN = Math.PI / 180;
//     const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
//     const x = cx + radius * Math.cos(-midAngle * RADIAN);
//     const y = cy + radius * Math.sin(-midAngle * RADIAN);
//     const percentage = (value / totalEvents) * 100;
//     if (percentage > 2) {
//       return (
//         <text
//           x={x}
//           y={y}
//           fill="white"
//           textAnchor={x > cx ? 'start' : 'end'}
//           dominantBaseline="central"
//           style={{ fontSize: '12px', fontWeight: 500 }}
//         >
//           {`${percentage.toFixed(1)}%`}
//         </text>
//       );
//     }
//     return null;
//   };

//   const legendData = Object.keys(eventData).map(zone => ({
//     zone,
//     color: zoneColors[zone],
//     total: eventData[zone].total,
//     percentage: ((eventData[zone].total / totalEvents) * 100).toFixed(1),
//     regions: Object.keys(eventData[zone])
//       .filter(key => key !== 'total')
//       .map((region, index) => ({
//         name: region,
//         value: eventData[zone][region],
//         color: getRegionColor(zone, index),
//         percentage: ((eventData[zone][region] / totalEvents) * 100).toFixed(1)
//       }))
//   }));

//   return (
//     <div className="card h-100" style={{ background: colors.light }}>
//       <div className="card-body">
//         <h6 className="mb-4 text-center" style={{ fontWeight: 600, fontSize: '1.125rem', color: colors.dark }}>
//           Zone & Region Event Distribution
//         </h6>
//         <div className="text-center mb-4">
//           <div style={{
//             display: 'inline-block',
//             backgroundColor: 'rgba(255,255,255,0.7)',
//             padding: '0.5rem 1rem',
//             borderRadius: '20px',
//             border: `1px solid ${colors.primary}`
//           }}>
//             <span style={{ fontSize: '1rem', fontWeight: 600, color: colors.dark }}>
//               Total Events: {totalEvents.toLocaleString()}
//             </span>
//           </div>
//         </div>

//         <div className="row">
//           <div className="col-md-6 d-flex justify-content-center align-items-center">
//             <div style={{ height: '350px', width: '100%' }}>
//               <ResponsiveContainer width="100%" height="100%">
//                 <PieChart>
//                   <Pie
//                     data={pieData}
//                     cx="50%"
//                     cy="50%"
//                     labelLine={false}
//                     label={renderCustomizedLabel}
//                     outerRadius={120}
//                     fill="#8884d8"
//                     dataKey="value"
//                     startAngle={90}
//                     endAngle={450}
//                   >
//                     {pieData.map((entry, index) => (
//                       <Cell
//                         key={`cell-${index}`}
//                         fill={entry.color}
//                         stroke={entry.isSeparator ? '#ffffff' : zoneColors[entry.zone]}
//                         strokeWidth={entry.isSeparator ? 0 : 2}
//                       />
//                     ))}
//                   </Pie>
//                   <Tooltip content={<CustomTooltip />} />
//                 </PieChart>
//               </ResponsiveContainer>
//             </div>
//           </div>

//           <div className="col-md-6">
//             <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
//                 {legendData.map((zoneData, zoneIndex) => (
//                   <div key={zoneData.zone} style={{
//                     backgroundColor: 'rgba(255,255,255,0.8)',
//                     padding: '0.75rem',
//                     borderRadius: '8px',
//                     borderLeft: `4px solid ${zoneData.color}`,
//                     marginBottom: '0.5rem'
//                   }}>
//                     <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
//                       <div
//                         style={{
//                           width: '12px',
//                           height: '12px',
//                           borderRadius: '50%',
//                           backgroundColor: zoneData.color,
//                           marginRight: '0.5rem'
//                         }}
//                       ></div>
//                       <span style={{ fontWeight: 600, fontSize: '0.875rem', color: colors.dark }}>
//                         {zoneData.zone}
//                       </span>
//                       <span style={{ marginLeft: 'auto', fontSize: '0.75rem', color: colors.dark }}>
//                         {zoneData.percentage}%
//                       </span>
//                     </div>
//                     <div style={{ marginLeft: '1rem' }}>
//                       {zoneData.regions.map((regionData, regionIndex) => (
//                         <div key={regionData.name} style={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           fontSize: '0.75rem',
//                           marginBottom: '0.25rem',
//                           color: colors.dark
//                         }}>
//                           <div
//                             style={{
//                               width: '8px',
//                               height: '8px',
//                               borderRadius: '50%',
//                               backgroundColor: regionData.color,
//                               marginRight: '0.375rem'
//                             }}
//                           ></div>
//                           <span style={{ opacity: 0.9 }}>{regionData.name}</span>
//                           <span style={{ marginLeft: 'auto', opacity: 0.8 }}>
//                             {regionData.percentage}%
//                           </span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // EventFilters component with updated colors and icons
// const EventFilters = () => {
//   const { filters, setFilters, events } = useDashboardStore();
//   const regions = [...new Set(events.map(event => event.region))];
//   const zones = [...new Set(events
//     .filter(event => filters.region === 'all' || event.region === filters.region)
//     .map(event => event.zone))];

//   return (
//     <div className="card mb-4" style={{
//       background: colors.light,
//       border: `1px solid ${colors.primary}`,
//       borderRadius: '8px'
//     }}>
//       <div className="card-body">
//         <h6 className="mb-3" style={{ fontWeight: 600, color: "white"}}>
//           Smart Filters
//         </h6>
//         <div className="row g-3">
//           <div className="col-12 col-sm-6 col-lg-3">
//             <label className="form-label" style={{ fontSize: '0.875rem', fontWeight: 500, color: colors.dark }}>Region</label>
//             <select
//               className="form-select form-select-sm"
//               value={filters.region}
//               onChange={(e) => setFilters({ region: e.target.value, zone: 'all' })}
//               style={{
//                 backgroundColor: 'white',
//                 border: `1px solid ${colors.primary}`,
//                 borderRadius: '8px'
//               }}
//             >
//               <option value="all">All Regions</option>
//               {regions.map(region => (
//                 <option key={region} value={region}>{region}</option>
//               ))}
//             </select>
//           </div>
//           <div className="col-12 col-sm-6 col-lg-3">
//             <label className="form-label" style={{ fontSize: '0.875rem', fontWeight: 500, color: colors.dark }}>Zone</label>
//             <select
//               className="form-select form-select-sm"
//               value={filters.zone}
//               onChange={(e) => setFilters({ zone: e.target.value })}
//               disabled={filters.region === 'all'}
//               style={{
//                 backgroundColor: 'white',
//                 border: `1px solid ${colors.primary}`,
//                 borderRadius: '8px'
//               }}
//             >
//               <option value="all">All Zones</option>
//               {zones.map(zone => (
//                 <option key={zone} value={zone}>{zone}</option>
//               ))}
//             </select>
//           </div>
//           <div className="col-12 col-sm-6 col-lg-3">
//             <label className="form-label" style={{ fontSize: '0.875rem', fontWeight: 500, color: colors.dark }}>Event Type</label>
//             <select
//               className="form-select form-select-sm"
//               value={filters.eventType}
//               onChange={(e) => setFilters({ eventType: e.target.value })}
//               style={{
//                 backgroundColor: 'white',
//                 border: `1px solid ${colors.primary}`,
//                 borderRadius: '8px'
//               }}
//             >
//               <option value="all">All Events</option>
//               <option value="live">Live</option>
//               <option value="upcoming">Upcoming</option>
//               <option value="past">Past</option>
//             </select>
//           </div>
//           <div className="col-12 col-sm-6 col-lg-3">
//             <label className="form-label" style={{ fontSize: '0.875rem', fontWeight: 500, color: colors.dark }}>Start Date</label>
//             <input
//               type="date"
//               className="form-control form-control-sm"
//               value={filters.dateRange.start}
//               onChange={(e) => setFilters({
//                 dateRange: { ...filters.dateRange, start: e.target.value }
//               })}
//               style={{
//                 backgroundColor: 'white',
//                 border: `1px solid ${colors.primary}`,
//                 borderRadius: '8px'
//               }}
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // KPIStats component with updated colors and icons
// const KPIStats = () => {
//   const { kpis } = useDashboardStore();
//   const nav = useNavigate();
//   if (!kpis) return null;

//   const kpiCards = [
//     {
//       title: 'Total Loan Disbursed',
//       value: `₹${(kpis.totalLoanDisbursed / 1000000).toFixed(2)}M`,
//       icon: '₹',
//       color: colors.pastel1,
//       iconBg: 'rgba(255,255,255,0.7)'
//     },
//     {
//       title: 'Winning Bids',
//       value: kpis.totalWinningBids.toString(),
//       icon: '★',
//       color: colors.pastel2,
//       iconBg: 'rgba(255,255,255,0.7)'
//     },
//     {
//       title: 'Total Events',
//       value: kpis.totalEvents.toString(),
//       icon: '▪',
//       color: colors.pastel3,
//       iconBg: 'rgba(255,255,255,0.7)'
//     },
//     {
//       title: 'Cars Mapped',
//       value: kpis.totalCarsMapped.toString(),
//       icon: '⚙',
//       color: colors.pastel4,
//       iconBg: 'rgba(255,255,255,0.7)'
//     },
//   ];

//   return (
//     <div className="mb-5">
//       <div className="text-center mb-1">
//         <h2 style={{
//           fontWeight: 700,
//           color: "#ee373b",
//           fontSize: '2rem'
//         }}>
//           Dashboard Overview
//         </h2>
//         <p style={{ color: "black", fontSize: '1.125rem' }}>
//           Real-time insights and performance metrics
//         </p>
//         <div className='w-100 d-flex justify-content-end'>
//           <button className='mb-2 btn btn-outline-danger' onClick={()=>{
//             nav("/manageZoneRegion")
//           }}>Manage Zone/Regions</button>
//         </div>
//       </div>
//       <div className="row g-4">
//         {kpiCards.map((kpi, index) => (
//           <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={index}>
//             <div
//               className="card h-100 border-0 position-relative overflow-hidden"
//               style={{
//                 background: kpi.color,
//                 borderRadius: '20px',
//                 boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
//                 transition: 'all 0.3s ease',
//                 cursor: 'pointer'
//               }}
//               onMouseOver={(e) => {
//                 e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
//                 e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
//               }}
//               onMouseOut={(e) => {
//                 e.currentTarget.style.transform = 'none';
//                 e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.05)';
//               }}
//             >
//               <div className="card-body text-dark p-3">
//                 <div className="d-flex align-items-center mb-3">
//                   <div style={{
//                     width: '50px',
//                     height: '50px',
//                     backgroundColor: kpi.iconBg,
//                     borderRadius: '15px',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     fontSize: '1.5rem',
//                     border: `1px solid ${kpi.color}`
//                   }}>
//                     {kpi.icon}
//                   </div>
//                 </div>
//                 <h3 style={{
//                   fontWeight: 700,
//                   marginBottom: '0.5rem',
//                   fontSize: '1.75rem',
//                   color: colors.dark
//                 }}>
//                   {kpi.value}
//                 </h3>
//                 <p style={{
//                   fontSize: '0.9rem',
//                   lineHeight: 1.4,
//                   marginBottom: 0,
//                   opacity: 0.9,
//                   color: colors.dark
//                 }}>
//                   {kpi.title}
//                 </p>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// // CustomerUploadChart component with updated colors
// const CustomerUploadChart = () => {
//   const { customerUploads } = useDashboardStore();
//   const chartData = customerUploads.map(upload => ({
//     region: `${upload.region}\n(${upload.zone})`,
//     uploaded: upload.totalUploaded,
//     allowed: upload.totalAllowed,
//     utilization: ((upload.totalUploaded / upload.totalAllowed) * 100).toFixed(1)
//   }));

//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       return (
//         <div style={{
//           backgroundColor: 'white',
//           padding: '1rem',
//           border: 'none',
//           borderRadius: '12px',
//           boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
//           backdropFilter: 'blur(10px)'
//         }}>
//           <p style={{ fontWeight: 600, marginBottom: '0.5rem', fontSize: '0.875rem', color: colors.dark }}>
//             {label.replace('\n', ' ')}
//           </p>
//           <p style={{ color: colors.success, marginBottom: '0.25rem', fontSize: '0.875rem' }}>
//             Customers Uploaded: {payload[0]?.value || 0}
//           </p>
//           <p style={{ color: colors.primary, marginBottom: '0.25rem', fontSize: '0.875rem' }}>
//             Total Allowed: {payload[1]?.value || 0}
//           </p>
//           <p style={{ color: colors.accent, marginBottom: 0, fontSize: '0.875rem' }}>
//             Utilization: {payload[0]?.payload?.utilization || 0}%
//           </p>
//         </div>
//       );
//     }
//     return null;
//   };

//   return (
//     <div className="card mb-4">
//       <div className="card-body">
//         <h6 className="mb-3" style={{ fontWeight: 600, color: colors.dark }}>
//           Customer Upload Status by Region
//         </h6>
//         <div style={{ width: '100%', height: '300px' }}>
//           <ResponsiveContainer>
//             <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
//               <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
//               <XAxis
//                 dataKey="region"
//                 tick={{ fontSize: 11 }}
//                 textAnchor="middle"
//               />
//               <YAxis
//                 tick={{ fontSize: 12 }}
//               />
//               <Tooltip content={<CustomTooltip />} />
//               <Legend />
//               <Bar
//                 dataKey="uploaded"
//                 name="Customers Uploaded"
//                 fill={colors.success}
//                 radius={[2, 2, 0, 0]}
//               />
//               <Bar
//                 dataKey="allowed"
//                 name="Total Allowed"
//                 fill={colors.primary}
//                 radius={[2, 2, 0, 0]}
//               />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>
//     </div>
//   );
// };

// // EventModal component with updated colors and icons
// const EventModal = () => {
//   const { selectedEvent, isEventModalOpen, setEventModalOpen } = useDashboardStore();
//   if (!selectedEvent) return null;

//   const getStatusColor = (status) => {
//     switch (status) {
//       case 'live': return 'success';
//       case 'upcoming': return 'warning';
//       case 'past': return 'secondary';
//       default: return 'secondary';
//     }
//   };

//   return (
//     <div className={`modal fade ${isEventModalOpen ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
//       <div className="modal-dialog modal-lg" role="document">
//         <div className="modal-content">
//           <div className="modal-header">
//             <div>
//               <h5 className="modal-title" style={{ fontWeight: 600, color: colors.dark }}>
//                 {selectedEvent.eventTitle}
//               </h5>
//               <span className={`badge bg-${getStatusColor(selectedEvent.status)} mt-1`}>
//                 {selectedEvent.status.toUpperCase()}
//               </span>
//             </div>
//             <button type="button" className="btn-close" onClick={() => setEventModalOpen(false)}></button>
//           </div>
//           <div className="modal-body">
//             <div className="row">
//               <div className="col-md-6">
//                 <div className="d-flex align-items-center mb-3">
//                   <span style={{ marginRight: '0.5rem', color: colors.dark }}>📍</span>
//                   <div>
//                     <p className="mb-1" style={{ color: colors.dark, fontSize: '0.875rem' }}>Location</p>
//                     <p className="mb-0 fw-bold">
//                       {selectedEvent.location} ({selectedEvent.region}, {selectedEvent.zone})
//                     </p>
//                   </div>
//                 </div>
//                 <div className="d-flex align-items-center mb-3">
//                   <span style={{ marginRight: '0.5rem', color: colors.dark }}>🕒</span>
//                   <div>
//                     <p className="mb-1" style={{ color: colors.dark, fontSize: '0.875rem' }}>Event Date & Time</p>
//                     <p className="mb-0 fw-bold">
//                       {formatDateTime(selectedEvent.startDate)} - {formatDateTime(selectedEvent.endDate)}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-md-6">
//                 <div className="d-flex align-items-center mb-3">
//                   <span style={{ marginRight: '0.5rem', color: colors.dark }}>⚙</span>
//                   <div>
//                     <p className="mb-1" style={{ color: colors.dark, fontSize: '0.875rem' }}>Total Cars</p>
//                     <p className="mb-0 fw-bold">
//                       {selectedEvent.totalCars}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="d-flex align-items-center mb-3">
//                   <span style={{ marginRight: '0.5rem', color: colors.dark }}>☰</span>
//                   <div>
//                     <p className="mb-1" style={{ color: colors.dark, fontSize: '0.875rem' }}>Total Users</p>
//                     <p className="mb-0 fw-bold">
//                       {selectedEvent.totalUsers}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <hr className="my-3" />
//             <h6 className="mb-3" style={{ fontWeight: 600, color: colors.dark }}>
//               Performance Metrics
//             </h6>
//             <div className="row">
//               <div className="col-6 col-sm-3 mb-2">
//                 <div style={{
//                   textAlign: 'center',
//                   padding: '1rem',
//                   backgroundColor: colors.light,
//                   borderRadius: '4px',
//                   border: `1px solid ${colors.primary}`
//                 }}>
//                   <h4 style={{ fontWeight: 700, color: colors.primary }}>
//                     {selectedEvent.totalWinningBids}
//                   </h4>
//                   <p style={{ color: colors.dark, marginBottom: 0 }}>
//                     Winning Bids
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6 col-sm-3 mb-2">
//                 <div style={{
//                   textAlign: 'center',
//                   padding: '1rem',
//                   backgroundColor: colors.light,
//                   borderRadius: '4px',
//                   border: `1px solid ${colors.success}`
//                 }}>
//                   <h4 style={{ fontWeight: 700, color: colors.success }}>
//                     ₹{(selectedEvent.loanDisbursed / 100000).toFixed(1)}L
//                   </h4>
//                   <p style={{ color: colors.dark, marginBottom: 0 }}>
//                     Loan Disbursed
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6 col-sm-3 mb-2">
//                 <div style={{
//                   textAlign: 'center',
//                   padding: '1rem',
//                   backgroundColor: colors.light,
//                   borderRadius: '4px',
//                   border: `1px solid ${colors.warning}`
//                 }}>
//                   <h4 style={{ fontWeight: 700, color: colors.warning }}>
//                     {selectedEvent.loanSuccessRate.toFixed(1)}%
//                   </h4>
//                   <p style={{ color: colors.dark, marginBottom: 0 }}>
//                     Success Rate
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6 col-sm-3 mb-2">
//                 <div style={{
//                   textAlign: 'center',
//                   padding: '1rem',
//                   backgroundColor: colors.light,
//                   borderRadius: '4px',
//                   border: `1px solid ${colors.info}`
//                 }}>
//                   <h4 style={{ fontWeight: 700, color: colors.info }}>
//                     {selectedEvent.totalCars}
//                   </h4>
//                   <p style={{ color: colors.dark, marginBottom: 0 }}>
//                     Cars Available
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="modal-footer">
//             <button
//               type="button"
//               className="btn btn-primary"
//               onClick={() => setEventModalOpen(false)}
//               style={{
//                 padding: '0.5rem 2rem',
//                 backgroundColor: colors.primary,
//                 borderColor: colors.primary
//               }}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // EventSummaryTable component with updated colors
// const EventSummaryTable = () => {
//   const { events, setSelectedEvent, setEventModalOpen } = useDashboardStore();

//   const getStatusColor = (status) => {
//     switch (status) {
//       case 'live': return 'success';
//       case 'upcoming': return 'warning';
//       case 'past': return 'secondary';
//       default: return 'secondary';
//     }
//   };

//   return (
//     <div className="card mb-4">
//       <div className="card-body">
//         <h6 className="mb-3" style={{ fontWeight: 600, color: colors.dark }}>
//           Event Summary
//         </h6>
//         <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
//           <table className="table table-hover">
//             <thead style={{ backgroundColor: colors.light }}>
//               <tr>
//                 <th>Event Title</th>
//                 <th>Location</th>
//                 <th>Region</th>
//                 <th>Zone</th>
//                 <th>Date</th>
//                 <th>Cars</th>
//                 <th>Users</th>
//                 <th>Winning Bids</th>
//                 <th>Loan Disbursed</th>
//                 <th>Success Rate</th>
//                 <th>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {events.map(event => (
//                 <tr key={event.eventId} style={{ cursor: 'pointer' }} onClick={() => {
//                   setSelectedEvent(event);
//                   setEventModalOpen(true);
//                 }}>
//                   <td style={{ color: colors.primary, fontWeight: 500 }}>{event.eventTitle}</td>
//                   <td>{event.location}</td>
//                   <td>{event.region}</td>
//                   <td>{event.zone}</td>
//                   <td>{formatDate(event.startDate)}</td>
//                   <td>{event.totalCars}</td>
//                   <td>{event.totalUsers}</td>
//                   <td>{event.totalWinningBids}</td>
//                   <td>₹{(event.loanDisbursed / 100000).toFixed(2)}L</td>
//                   <td>{event.loanSuccessRate.toFixed(1)}%</td>
//                   <td>
//                     <span className={`badge bg-${getStatusColor(event.status)}`}>
//                       {event.status.toUpperCase()}
//                     </span>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// // LoanDisbursementChart component with updated colors
// const LoanDisbursementChart = () => {
//   const { events } = useDashboardStore();
//   const chartData = events
//     .filter(event => event.loanDisbursed > 0)
//     .map(event => ({
//       eventTitle: event.eventTitle.length > 15
//         ? `${event.eventTitle.substring(0, 15)}...`
//         : event.eventTitle,
//       loanDisbursed: event.loanDisbursed / 100000, // Convert to lakhs
//       region: event.region,
//       zone: event.zone
//     }));

//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       return (
//         <div style={{
//           backgroundColor: 'white',
//           padding: '0.75rem',
//           border: 'none',
//           borderRadius: '12px',
//           boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
//           backdropFilter: 'blur(10px)'
//         }}>
//           <p style={{ fontWeight: 600, marginBottom: '0.5rem', color: colors.dark }}>
//             {label}
//           </p>
//           <p style={{ color: colors.primary, marginBottom: '0.25rem' }}>
//             Loan Disbursed: ₹{payload[0].value.toFixed(2)} Lakhs
//           </p>
//           <p style={{ color: colors.dark, fontSize: '0.75rem', marginBottom: 0 }}>
//             Region: {payload[0].payload.region} | Zone: {payload[0].payload.zone}
//           </p>
//         </div>
//       );
//     }
//     return null;
//   };

//   return (
//     <div className="card mb-4">
//       <div className="card-body">
//         <h6 className="mb-3" style={{ fontWeight: 600, color: colors.dark }}>
//           Loan Disbursement by Event
//         </h6>
//         <div style={{ width: '100%', height: '300px' }}>
//           <ResponsiveContainer>
//             <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
//               <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
//               <XAxis
//                 dataKey="eventTitle"
//                 tick={{ fontSize: 12 }}
//                 angle={-45}
//                 textAnchor="end"
//                 height={80}
//               />
//               <YAxis
//                 tick={{ fontSize: 12 }}
//                 tickFormatter={(value) => `₹${value}L`}
//               />
//               <Tooltip content={<CustomTooltip />} />
//               <Bar
//                 dataKey="loanDisbursed"
//                 fill={colors.primary}
//                 radius={[4, 4, 0, 0]}
//                 animationDuration={800}
//               />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>
//     </div>
//   );
// };

// // MonthlyTrendChart component with updated colors
// const MonthlyTrendChart = () => {
//   const { monthlyTrends } = useDashboardStore();
//   const chartData = monthlyTrends.map(trend => ({
//     ...trend,
//     loanDisbursed: trend.loanDisbursed / 100000 // Convert to lakhs
//   }));

//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       return (
//         <div style={{
//           backgroundColor: 'white',
//           padding: '0.75rem',
//           border: 'none',
//           borderRadius: '12px',
//           boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
//           backdropFilter: 'blur(10px)'
//         }}>
//           <p style={{ fontWeight: 600, marginBottom: '0.5rem', color: colors.dark }}>
//             {label}
//           </p>
//           <p style={{ color: colors.success, marginBottom: 0 }}>
//             Loan Disbursed: ₹{payload[0].value.toFixed(2)} Lakhs
//           </p>
//         </div>
//       );
//     }
//     return null;
//   };

//   return (
//     <div className="card mb-4">
//       <div className="card-body">
//         <h6 className="mb-3" style={{ fontWeight: 600, color: colors.dark }}>
//           Monthly Loan Disbursement Trend
//         </h6>
//         <div style={{ width: '100%', height: '300px' }}>
//           <ResponsiveContainer>
//             <AreaChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
//               <defs>
//                 <linearGradient id="colorLoan" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="5%" stopColor={colors.success} stopOpacity={0.8}/>
//                   <stop offset="95%" stopColor={colors.success} stopOpacity={0.1}/>
//                 </linearGradient>
//               </defs>
//               <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
//               <XAxis
//                 dataKey="month"
//                 tick={{ fontSize: 12 }}
//               />
//               <YAxis
//                 tick={{ fontSize: 12 }}
//                 tickFormatter={(value) => `₹${value}L`}
//               />
//               <Tooltip content={<CustomTooltip />} />
//               <Area
//                 type="monotone"
//                 dataKey="loanDisbursed"
//                 stroke={colors.success}
//                 strokeWidth={3}
//                 fillOpacity={1}
//                 fill="url(#colorLoan)"
//                 animationDuration={1000}
//               />
//             </AreaChart>
//           </ResponsiveContainer>
//         </div>
//       </div>
//     </div>
//   );
// };

// // RegionSuccessChart component with updated colors
// const RegionSuccessChart = () => {
//   const { regionData } = useDashboardStore();
//   const COLORS = [colors.primary, colors.success, colors.warning, colors.info];
//   const chartData = regionData.map(region => ({
//     name: `${region.region} (${region.zone})`,
//     value: region.successRate,
//     loanDisbursed: region.loanDisbursed,
//     winningBids: region.winningBids,
//     totalBids: region.totalBids
//   }));

//   const CustomTooltip = ({ active, payload }) => {
//     if (active && payload && payload.length) {
//       const data = payload[0].payload;
//       return (
//         <div style={{
//           backgroundColor: 'white',
//           padding: '0.75rem',
//           border: 'none',
//           borderRadius: '12px',
//           boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
//           backdropFilter: 'blur(10px)'
//         }}>
//           <p style={{ fontWeight: 600, marginBottom: '0.5rem', color: colors.dark }}>
//             {data.name}
//           </p>
//           <p style={{ color: colors.primary, marginBottom: '0.25rem' }}>
//             Success Rate: {data.value.toFixed(1)}%
//           </p>
//           <p style={{ color: colors.success, marginBottom: '0.25rem' }}>
//             Loan Disbursed: ₹{(data.loanDisbursed / 100000).toFixed(2)} Lakhs
//           </p>
//           <p style={{ color: colors.dark, marginBottom: 0 }}>
//             Winning Bids: {data.winningBids}/{data.totalBids}
//           </p>
//         </div>
//       );
//     }
//     return null;
//   };

//   return (
//     <div className="card mb-4">
//       <div className="card-body">
//         <h6 className="mb-3" style={{ fontWeight: 600, color: colors.dark }}>
//           Region & Zone Success Rate
//         </h6>
//         <div style={{ width: '100%', height: '350px' }}>
//           <ResponsiveContainer>
//             <PieChart>
//               <Pie
//                 data={chartData}
//                 cx="50%"
//                 cy="50%"
//                 outerRadius={120}
//                 fill="#8884d8"
//                 dataKey="value"
//                 animationDuration={800}
//                 animationBegin={0}
//               >
//                 {chartData.map((entry, index) => (
//                   <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                 ))}
//               </Pie>
//               <Tooltip content={<CustomTooltip />} />
//               <Legend
//                 verticalAlign="bottom"
//                 height={36}
//                 wrapperStyle={{ fontSize: '12px' }}
//               />
//             </PieChart>
//           </ResponsiveContainer>
//         </div>
//       </div>
//     </div>
//   );
// };

// // TopPerformingRegions component with updated colors
// const TopPerformingRegions = () => {
//   const { regionData, events } = useDashboardStore();
//   const topRegions = regionData
//     .map(region => {
//       const regionEvents = events.filter(event =>
//         event.region === region.region && event.zone === region.zone
//       );
//       return {
//         ...region,
//         eventsCount: regionEvents.length
//       };
//     })
//     .sort((a, b) => b.loanDisbursed - a.loanDisbursed)
//     .slice(0, 4);

//   const getPerformanceLevel = (successRate) => {
//     if (successRate >= 80) return { label: 'Excellent', color: 'success' };
//     if (successRate >= 70) return { label: 'Good', color: 'primary' };
//     if (successRate >= 60) return { label: 'Average', color: 'warning' };
//     return { label: 'Needs Improvement', color: 'danger' };
//   };

//   return (
//     <div className="card mb-4">
//       <div className="card-body">
//         <h6 className="mb-3" style={{ fontWeight: 600, color: colors.dark }}>
//           Top Performing Regions & Zones
//         </h6>
//         {topRegions.map((region, index) => {
//           const performance = getPerformanceLevel(region.successRate);
//           return (
//             <div
//               key={`${region.region}-${region.zone}`}
//               style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 padding: '1rem',
//                 marginBottom: '1rem',
//                 backgroundColor: index === 0 ? colors.pastel1 : colors.light,
//                 borderRadius: '8px',
//                 border: index === 0 ? `2px solid ${colors.accent}` : `1px solid ${colors.primary}`,
//                 transition: 'all 0.3s ease'
//               }}
//               onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
//               onMouseOut={(e) => e.currentTarget.style.transform = 'none'}
//             >
//               <div style={{
//                 width: '48px',
//                 height: '48px',
//                 backgroundColor: index === 0 ? colors.accent : colors.primary,
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 color: 'white',
//                 marginRight: '1rem',
//                 fontSize: '1.25rem'
//               }}>
//                 {index === 0 ? '★' : '△'}
//               </div>
//               <div style={{ flexGrow: 1 }}>
//                 <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
//                   <h6 style={{ fontWeight: 600, marginRight: '0.5rem', marginBottom: 0, color: colors.dark }}>
//                     {region.region} - {region.zone}
//                   </h6>
//                   {index === 0 && (
//                     <span className="badge bg-warning" style={{ fontWeight: 500, backgroundColor: colors.warning }}>
//                       Top Performer
//                     </span>
//                   )}
//                 </div>
//                 <div style={{ display: 'flex', gap: '1rem', marginBottom: '0.5rem' }}>
//                   <p style={{ color: colors.dark, marginBottom: 0 }}>
//                     <strong>Loan Disbursed:</strong> ₹{(region.loanDisbursed / 100000).toFixed(2)}L
//                   </p>
//                   <p style={{ color: colors.dark, marginBottom: 0 }}>
//                     <strong>Events:</strong> {region.eventsCount}
//                   </p>
//                 </div>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                   <p style={{ color: colors.dark, marginBottom: 0 }}>
//                     <strong>Success Rate:</strong> {region.successRate.toFixed(1)}%
//                   </p>
//                   <span className={`badge bg-${performance.color}`}>
//                     {performance.label}
//                   </span>
//                 </div>
//               </div>
//               <h4 style={{
//                 fontWeight: 700,
//                 color: index === 0 ? colors.accent : colors.primary,
//                 marginBottom: 0
//               }}>
//                 #{index + 1}
//               </h4>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// // Main App component with scrolling fixed and updated styles
// const App = () => {
//   const {
//     setKPIs,
//     setEvents,
//     setRegionData,
//     setMonthlyTrends,
//     setCustomerUploads,
//     setLoading,
//     loading
//   } = useDashboardStore();

//   useEffect(() => {
//     // Simulate API loading
//     setLoading(true);
//     // Simulate API call with setTimeout
//     const timer = setTimeout(() => {
//       setKPIs(mockKPIs);
//       setEvents(mockEvents);
//       setRegionData(mockRegionData);
//       setMonthlyTrends(mockMonthlyTrends);
//       setCustomerUploads(mockCustomerUploads);
//       setLoading(false);
//     }, 1000);
//     return () => clearTimeout(timer);
//   }, []);

//   if (loading) {
//     return (
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100vh',
//         backgroundColor: colors.light
//       }}>
//         <div className="spinner-border text-primary" role="status" style={{ color: colors.accent }}>
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={{
//       paddingTop: '2rem',
//       paddingBottom: '2rem',
//       maxHeight:"90vh",
//       overflowY: 'auto',
//     }}>
//       <div className="container-xl" style={{ maxWidth: '100%', overflow: 'hidden' }}>
//         {/* Header */}
//         {/* <div className="mb-4 text-center">
//           <h1 style={{
//             fontWeight: 700,
//             color: colors.dark,
//             marginBottom: '0.5rem',
//             fontSize: '2.5rem'
//           }}>
//             Master Lender Dashboard
//           </h1>
//           <h6 style={{
//             color: "white",
//             fontWeight: 400,
//             fontSize: '1.125rem'
//           }}>
//             Comprehensive Auction Event Analytics & Performance Monitoring
//           </h6>
//         </div> */}

//         {/* Filters */}
//         {/* <EventFilters /> */}

//         {/* KPI Stats */}
//         <KPIStats />

//         {/* Charts Grid */}
//         <div className="row mb-4">
//           <div className="col-lg-8 mb-3 mb-lg-0">
//             <LoanDisbursementChart />
//           </div>
//           <div className="col-lg-4">
//             <RegionSuccessChart />
//           </div>
//         </div>

//         <div className="row mb-4">
//           <div className="col-lg-6 mb-3 mb-lg-0">
//             <MonthlyTrendChart />
//           </div>
//           <div className="col-lg-6">
//             <CustomerUploadChart />
//           </div>
//         </div>

//         {/* Zone & Region Distribution */}
//         <ZoneRegionNestedPieChart />

//         {/* Top Performing Regions */}
//         <TopPerformingRegions />

//         {/* Event Summary Table */}
//         <EventSummaryTable />

//         {/* Event Modal */}
//         <EventModal />
//       </div>
//     </div>
//   );
// };

// export default App;


//======================================================================================

// import React, { useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import {
//   Bar,
//   Line,
//   Doughnut,
//   Pie,
//   Bubble,
//   PolarArea,
//   Scatter
// } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   PointElement,
//   LineElement,
//   ArcElement,
//   RadialLinearScale,
//   TimeScale,
//   TimeSeriesScale
// } from 'chart.js';
// import 'chartjs-adapter-date-fns'; // Add this line

// // Register ChartJS components
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   PointElement,
//   LineElement,
//   ArcElement,
//   RadialLinearScale,
//   TimeScale,
//   TimeSeriesScale
// );


// // Mock Data (Replace with API calls in a real app)
// const mockData = {
//   events: [
//     { id: 1, title: 'Mumbai Auto Expo', start: '2025-08-01T09:00:00', end: '2025-08-01T17:00:00' },
//     { id: 2, title: 'Delhi Car Auction', start: '2025-08-05T10:00:00', end: '2025-08-05T18:00:00' }
//   ],
//   mappedUsers: [
//     { eventId: 1, count: 120 },
//     { eventId: 2, count: 95 }
//   ],
//   registeredUsers: [
//     { eventId: 1, count: 85 },
//     { eventId: 2, count: 70 }
//   ],
//   activeBidders: [
//     { eventId: 1, count: 60 },
//     { eventId: 2, count: 50 }
//   ],
//   carsMapped: [
//     { eventId: 1, count: 40 },
//     { eventId: 2, count: 30 }
//   ],
//   carsSold: [
//     { eventId: 1, count: 32 },
//     { eventId: 2, count: 22 }
//   ],
//   carsNoBids: [
//     { eventId: 1, count: 5 },
//     { eventId: 2, count: 3 }
//   ],
//   carsMultipleBidders: [
//     { eventId: 1, count: 12, maxBid: 150000 },
//     { eventId: 2, count: 8, maxBid: 120000 }
//   ],
//   avgSalePrice: [
//     { eventId: 1, start: 500000, sale: 580000 },
//     { eventId: 2, start: 450000, sale: 520000 }
//   ],
//   totalBids: [
//     { eventId: 1, count: 450 },
//     { eventId: 2, count: 380 }
//   ],
//   bidActivity: [
//     { eventId: 1, bids: [10, 30, 50, 80, 100, 80, 60, 40] },
//     { eventId: 2, bids: [5, 25, 40, 70, 90, 70, 50, 30] }
//   ],
//   maxBidPerUser: [
//     { eventId: 1, data: { 'Dealer A': 850000, 'Dealer B': 720000, 'Dealer C': 680000 } },
//     { eventId: 2, data: { 'Dealer X': 650000, 'Dealer Y': 580000, 'Dealer Z': 520000 } }
//   ],
//   bidTimes: [
//     { eventId: 1, earliest: '2025-08-01T09:15:00', latest: '2025-08-01T16:45:00' },
//     { eventId: 2, earliest: '2025-08-05T10:30:00', latest: '2025-08-05T17:50:00' }
//   ],
//   carsWonPerBuyer: [
//     { eventId: 1, data: { 'Dealer A': 8, 'Dealer B': 6, 'Dealer C': 5 } },
//     { eventId: 2, data: { 'Dealer X': 6, 'Dealer Y': 5, 'Dealer Z': 4 } }
//   ],
//   totalRevenue: [
//     { eventId: 1, revenue: 18560000 },
//     { eventId: 2, revenue: 11440000 }
//   ],
//   topBuyers: [
//     { eventId: 1, data: [
//       { name: 'Dealer A', spend: 6800000 },
//       { name: 'Dealer B', spend: 4200000 },
//       { name: 'Dealer C', spend: 3500000 }
//     ]},
//     { eventId: 2, data: [
//       { name: 'Dealer X', spend: 4500000 },
//       { name: 'Dealer Y', spend: 3800000 },
//       { name: 'Dealer Z', spend: 3100000 }
//     ]}
//   ],
//   winRatio: [
//     { eventId: 1, ratio: 0.75 },
//     { eventId: 2, ratio: 0.68 }
//   ],
//   avgOverbid: [
//     { eventId: 1, percent: 16 },
//     { eventId: 2, percent: 14 }
//   ],
//   regions: [
//     { id: 1, name: 'North' },
//     { id: 2, name: 'South' },
//     { id: 3, name: 'East' },
//     { id: 4, name: 'West' }
//   ],
//   regionPerformance: [
//     { regionId: 1, revenue: 12000000, carsSold: 25 },
//     { regionId: 2, revenue: 9500000, carsSold: 20 },
//     { regionId: 3, revenue: 8000000, carsSold: 15 },
//     { regionId: 4, revenue: 6000000, carsSold: 10 }
//   ],
//   lenderPerformance: [
//     { lenderId: 1, name: 'Premier Motors', eventsHosted: 3, revenue: 25000000, participationRate: 82, conversionRate: 78 },
//     { lenderId: 2, name: 'Elite Cars', eventsHosted: 2, revenue: 18000000, participationRate: 75, conversionRate: 70 }
//   ]
// };

// const Dashboard = () => {
//   // Helper functions
//   const getEventDuration = (start, end) => {
//     const startTime = new Date(start);
//     const endTime = new Date(end);
//     return (endTime - startTime) / (1000 * 60); // Minutes
//   };

//   const calculateBiddingIntensity = (eventId) => {
//     const bids = mockData.totalBids.find(e => e.eventId === eventId)?.count || 0;
//     const event = mockData.events.find(e => e.id === eventId);
//     const duration = event ? getEventDuration(event.start, event.end) : 1;
//     return (bids / duration).toFixed(2);
//   };

//   // Chart options
//   const chartOptions = {
//     responsive: true,
//     plugins: {
//       legend: { position: 'top' },
//       title: { display: true, font: { size: 14 } }
//     }
//   };

//   return (
//     <div className="container-fluid p-3" style={{maxHeight:"90vh", overflow:"scroll"}}>
//       <h1 className="my-4 text-center">Auction Dashboard</h1>

//       {/* 1. Event Participation Metrics */}
//       <section className="mb-5">
//         <h2 className="mb-4">Event Participation Metrics</h2>
//         <div className="row g-4">
//           {/* Mapped Users Count (Vertical Bar) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">Mapped Users Count</div>
//               <div className="card-body">
//                 <Bar
//                   data={{
//                     labels: mockData.events.map((e) => e.title),
//                     datasets: [
//                       {
//                         label: "Users",
//                         data: mockData.mappedUsers.map((e) => e.count),
//                         backgroundColor: "rgba(54, 162, 235, 0.7)",
//                       },
//                     ],
//                   }}
//                   options={{
//                     ...chartOptions,
//                     plugins: { title: { text: "Users Mapped to Events" } },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Registered vs Agreement-Signed (Grouped Bar) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">User Registration</div>
//               <div className="card-body">
//                 <Bar
//                   data={{
//                     labels: mockData.events.map((e) => e.title),
//                     datasets: [
//                       {
//                         label: "Registered",
//                         data: mockData.registeredUsers.map((e) => e.count),
//                         backgroundColor: "rgba(75, 192, 192, 0.7)",
//                       },
//                       {
//                         label: "Agreement-Signed",
//                         data: mockData.registeredUsers.map(
//                           (e) => e.count * 0.9
//                         ),
//                         backgroundColor: "rgba(153, 102, 255, 0.7)",
//                       },
//                     ],
//                   }}
//                   options={{
//                     ...chartOptions,
//                     plugins: { title: { text: "Registered vs Signed Users" } },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* User Registration Ratio (Progress Bars) */}
//           <div className="col-md-12">
//             <div className="card">
//               <div className="card-header">User Registration Ratio</div>
//               <div className="card-body">
//                 {mockData.events.map((event) => {
//                   const regUsers =
//                     mockData.registeredUsers.find((e) => e.eventId === event.id)
//                       ?.count || 0;
//                   const mappedUsers =
//                     mockData.mappedUsers.find((e) => e.eventId === event.id)
//                       ?.count || 1;
//                   const ratio = ((regUsers / mappedUsers) * 100).toFixed(1);
//                   return (
//                     <div key={event.id} className="mb-3">
//                       <div className="d-flex justify-content-between mb-1">
//                         <span>{event.title}</span>
//                         <span>{ratio}%</span>
//                       </div>
//                       <div className="progress" style={{ height: "20px" }}>
//                         <div
//                           className="progress-bar"
//                           role="progressbar"
//                           style={{ width: `${ratio}%` }}
//                         ></div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>

//           {/* Active Bidders (Donut) + Inactive (Stacked) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">Bidder Activity</div>
//               <div className="card-body">
//                 {mockData.events.map((event) => {
//                   const active =
//                     mockData.activeBidders.find((e) => e.eventId === event.id)
//                       ?.count || 0;
//                   const registered =
//                     mockData.registeredUsers.find((e) => e.eventId === event.id)
//                       ?.count || 0;
//                   const inactive = registered - active;
//                   return (
//                     <div key={event.id} className="mb-4">
//                       <h6 className="text-center">{event.title}</h6>
//                       <Doughnut
//                         data={{
//                           labels: ["Active Bidders", "Inactive Users"],
//                           datasets: [
//                             {
//                               data: [active, inactive],
//                               backgroundColor: [
//                                 "rgba(75, 192, 192, 0.7)",
//                                 "rgba(255, 99, 132, 0.7)",
//                               ],
//                             },
//                           ],
//                         }}
//                         options={{
//                           ...chartOptions,
//                           plugins: {
//                             title: {
//                               text: `Active: ${active} | Inactive: ${inactive}`,
//                             },
//                           },
//                         }}
//                       />
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>

//           {/* Average Bids per Active User (KPI Cards) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">Average Bids per Active User</div>
//               <div className="card-body">
//                 {mockData.events.map((event) => {
//                   const bids =
//                     mockData.totalBids.find((e) => e.eventId === event.id)
//                       ?.count || 0;
//                   const active =
//                     mockData.activeBidders.find((e) => e.eventId === event.id)
//                       ?.count || 1;
//                   const avg = (bids / active).toFixed(1);
//                   return (
//                     <div key={event.id} className="p-3 mb-3 border rounded">
//                       <h3 className="display-4">{avg}</h3>
//                       <p className="mb-0">for {event.title}</p>
//                       <div className="progress" style={{ height: "5px" }}>
//                         <div
//                           className="progress-bar bg-warning"
//                           style={{ width: "30%" }}
//                         ></div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* 2. Car Metrics */}
//       <section className="mb-5">
//         <h2 className="mb-4">Car Metrics</h2>
//         <div className="row g-4">
//           {/* Total Cars Mapped (Column Chart) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">Cars Mapped to Events</div>
//               <div className="card-body">
//                 <Bar
//                   data={{
//                     labels: mockData.events.map((e) => e.title),
//                     datasets: [
//                       {
//                         label: "Cars",
//                         data: mockData.carsMapped.map((e) => e.count),
//                         backgroundColor: "rgba(255, 159, 64, 0.7)",
//                       },
//                     ],
//                   }}
//                   options={{
//                     ...chartOptions,
//                     plugins: { title: { text: "Total Cars per Event" } },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Cars with No Bids (Big Number + Mini Pie) */}
//           <div className="col-md-3">
//             <div className="card h-100">
//               <div className="card-header">Cars with No Bids</div>
//               <div className="card-body text-center">
//                 <h2 className="display-4">
//                   {mockData.carsNoBids.reduce((sum, car) => sum + car.count, 0)}
//                 </h2>
//                 <Pie
//                   data={{
//                     labels: ["With Bids", "No Bids"],
//                     datasets: [
//                       {
//                         data: [
//                           mockData.carsMapped
//                             .map((e) => e.count)
//                             .reduce((a, b) => a + b, 0) -
//                             mockData.carsNoBids
//                               .map((e) => e.count)
//                               .reduce((a, b) => a + b, 0),
//                           mockData.carsNoBids
//                             .map((e) => e.count)
//                             .reduce((a, b) => a + b, 0),
//                         ],
//                         backgroundColor: [
//                           "rgba(75, 192, 192, 0.7)",
//                           "rgba(255, 99, 132, 0.7)",
//                         ],
//                       },
//                     ],
//                   }}
//                   options={{
//                     ...chartOptions,
//                     plugins: { legend: { position: "bottom" } },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Cars with Multiple Bidders (Bubble Chart) */}
//           <div className="col-md-3">
//             <div className="card h-100">
//               <div className="card-header">Competitive Cars</div>
//               <div className="card-body">
//                 <Bubble
//                   data={{
//                     datasets: mockData.carsMultipleBidders.map((car, i) => ({
//                       label: mockData.events[i].title,
//                       data: [{ x: i + 1, y: car.count, r: car.maxBid / 50000 }],
//                       backgroundColor: `rgba(${Math.random() * 255}, ${
//                         Math.random() * 255
//                       }, ${Math.random() * 255}, 0.7)`,
//                     })),
//                   }}
//                   options={{
//                     ...chartOptions,
//                     plugins: { title: { text: "Bidders per Car" } },
//                     scales: {
//                       x: { title: { display: true, text: "Event" } },
//                       y: { title: { display: true, text: "Bidders" } },
//                     },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Cars Sold/Unsold (Pie Chart) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">Sales Performance</div>
//               <div className="card-body">
//                 <Pie
//                   data={{
//                     labels: ["Sold", "Unsold"],
//                     datasets: [
//                       {
//                         data: [
//                           mockData.carsSold
//                             .map((e) => e.count)
//                             .reduce((a, b) => a + b, 0),
//                           mockData.carsMapped
//                             .map((e) => e.count)
//                             .reduce((a, b) => a + b, 0) -
//                             mockData.carsSold
//                               .map((e) => e.count)
//                               .reduce((a, b) => a + b, 0),
//                         ],
//                         backgroundColor: [
//                           "rgba(75, 192, 192, 0.7)",
//                           "rgba(255, 99, 132, 0.7)",
//                         ],
//                       },
//                     ],
//                   }}
//                   options={{
//                     ...chartOptions,
//                     plugins: { title: { text: "Sold vs Unsold Cars" } },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Avg. Sale Price vs Start Price (Dual Line) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">Price Comparison</div>
//               <div className="card-body">
//                 <Line
//                   data={{
//                     labels: mockData.events.map((e) => e.title),
//                     datasets: [
//                       {
//                         label: "Start Price",
//                         data: mockData.avgSalePrice.map((e) => e.start),
//                         borderColor: "rgba(255, 99, 132, 1)",
//                         backgroundColor: "rgba(255, 99, 132, 0.2)",
//                       },
//                       {
//                         label: "Sale Price",
//                         data: mockData.avgSalePrice.map((e) => e.sale),
//                         borderColor: "rgba(54, 162, 235, 1)",
//                         backgroundColor: "rgba(54, 162, 235, 0.2)",
//                       },
//                     ],
//                   }}
//                   options={{
//                     ...chartOptions,
//                     plugins: { title: { text: "Average Prices" } },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* 3. Bid Metrics */}
//       <section className="mb-5">
//         <h2 className="mb-4">Bid Metrics</h2>
//         <div className="row g-4">
//           {/* Total Bids (Bar Chart) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">Total Bids Placed</div>
//               <div className="card-body">
//                 <Bar
//                   data={{
//                     labels: mockData.events.map((e) => e.title),
//                     datasets: [
//                       {
//                         label: "Bids",
//                         data: mockData.totalBids.map((e) => e.count),
//                         backgroundColor: "rgba(153, 102, 255, 0.7)",
//                       },
//                     ],
//                   }}
//                   options={{
//                     ...chartOptions,
//                     plugins: { title: { text: "Bids per Event" } },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Max Bid per User (Horizontal Bar) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">Top Bidders</div>
//               <div className="card-body">
//                 {mockData.events.map((event) => {
//                   const bids =
//                     mockData.maxBidPerUser.find((e) => e.eventId === event.id)
//                       ?.data || {};
//                   return (
//                     <div key={event.id} className="mb-4">
//                       <h6>{event.title}</h6>
//                       <Bar
//                         data={{
//                           labels: Object.keys(bids),
//                           datasets: [
//                             {
//                               label: "Max Bid (₹)",
//                               data: Object.values(bids),
//                               backgroundColor: "rgba(255, 159, 64, 0.7)",
//                             },
//                           ],
//                         }}
//                         options={{
//                           ...chartOptions,
//                           indexAxis: "y",
//                           plugins: { title: { text: "Highest Bids per User" } },
//                         }}
//                       />
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>

//           {/* Highest Bid (Highlight Card) */}
//           <div className="col-md-4">
//             <div className="card h-100 text-center">
//               <div className="card-header">Highest Bid</div>
//               <div className="card-body">
//                 <h1 className="display-2">
//                   ₹{Math.max(...mockData.avgSalePrice.map((e) => e.sale))}
//                 </h1>
//                 <i
//                   className="bi bi-trophy-fill text-warning"
//                   style={{ fontSize: "3rem" }}
//                 ></i>
//               </div>
//             </div>
//           </div>

//           {/* Bid Times (Scatter Plot) */}
//           <div className="col-md-8">
//             <div className="card h-100">
//               <div className="card-header">Bid Activity Timeline</div>
//               <div className="card-body">
//                 <Scatter
//                   data={{
//                     datasets: mockData.events.map((event, i) => {
//                       const times = mockData.bidTimes.find(
//                         (e) => e.eventId === event.id
//                       );
//                       return {
//                         label: event.title,
//                         data: [
//                           {
//                             x: new Date(times?.earliest),
//                             y: Math.random() * 1000000,
//                           },
//                           {
//                             x: new Date(times?.latest),
//                             y: Math.random() * 1000000,
//                           },
//                         ],
//                         backgroundColor: `rgba(${Math.random() * 255}, ${
//                           Math.random() * 255
//                         }, ${Math.random() * 255}, 0.7)`,
//                       };
//                     }),
//                   }}
//                   options={{
//                     responsive: true,
//                     scales: {
//                       x: {
//                         type: "time",
//                         time: {
//                           unit: "hour",
//                           displayFormats: {
//                             hour: "HH:mm",
//                           },
//                         },
//                         title: {
//                           display: true,
//                           text: "Time",
//                         },
//                       },
//                       y: {
//                         title: {
//                           display: true,
//                           text: "Bid Amount (₹)",
//                         },
//                       },
//                     },
//                     plugins: {
//                       legend: {
//                         position: "top",
//                       },
//                       title: {
//                         display: true,
//                         text: "Earliest and Latest Bids",
//                         font: {
//                           size: 14,
//                         },
//                       },
//                     },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Bid Activity Over Time (Area Chart) */}
//           <div className="col-md-12">
//             <div className="card">
//               <div className="card-header">Bid Activity Over Time</div>
//               <div className="card-body">
//                 <Line
//                   data={{
//                     labels: [
//                       "9AM",
//                       "10AM",
//                       "11AM",
//                       "12PM",
//                       "1PM",
//                       "2PM",
//                       "3PM",
//                       "4PM",
//                     ],
//                     datasets: mockData.bidActivity.map((activity, i) => ({
//                       label: mockData.events[i].title,
//                       data: activity.bids,
//                       borderColor: `rgba(${Math.random() * 255}, ${
//                         Math.random() * 255
//                       }, ${Math.random() * 255}, 1)`,
//                       backgroundColor: `rgba(${Math.random() * 255}, ${
//                         Math.random() * 255
//                       }, ${Math.random() * 255}, 0.2)`,
//                       fill: true,
//                     })),
//                   }}
//                   options={{
//                     ...chartOptions,
//                     plugins: { title: { text: "Bids per Hour" } },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Bidding Intensity (Heatmap-like Bar) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">Bidding Intensity</div>
//               <div className="card-body">
//                 <Bar
//                   data={{
//                     labels: mockData.events.map((e) => e.title),
//                     datasets: [
//                       {
//                         label: "Bids per Minute",
//                         data: mockData.events.map((e) =>
//                           calculateBiddingIntensity(e.id)
//                         ),
//                         backgroundColor: mockData.events.map((e) => {
//                           const intensity = parseFloat(
//                             calculateBiddingIntensity(e.id)
//                           );
//                           return `rgba(${Math.min(
//                             255,
//                             intensity * 10
//                           )}, ${Math.min(255, 255 - intensity * 10)}, 50, 0.7)`;
//                         }),
//                       },
//                     ],
//                   }}
//                   options={{
//                     ...chartOptions,
//                     plugins: { title: { text: "Bids per Minute of Auction" } },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* 4. Win Metrics */}
//       <section className="mb-5">
//         <h2 className="mb-4">Win Metrics</h2>
//         <div className="row g-4">
//           {/* Cars Won per Buyer (Leaderboard) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">Top Buyers by Cars Won</div>
//               <div className="card-body">
//                 {mockData.events.map((event) => {
//                   const buyers =
//                     mockData.carsWonPerBuyer.find((e) => e.eventId === event.id)
//                       ?.data || {};
//                   return (
//                     <div key={event.id} className="mb-4">
//                       <h6>{event.title}</h6>
//                       <table className="table table-striped">
//                         <thead>
//                           <tr>
//                             <th>Rank</th>
//                             <th>Buyer</th>
//                             <th>Cars Won</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {Object.entries(buyers)
//                             .sort((a, b) => b[1] - a[1])
//                             .map(([name, count], i) => (
//                               <tr key={name}>
//                                 <td>{i + 1}</td>
//                                 <td>{name}</td>
//                                 <td>{count}</td>
//                               </tr>
//                             ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>

//           {/* Total Revenue (Big Number) */}
//           <div className="col-md-3">
//             <div className="card h-100 text-center">
//               <div className="card-header">Total Revenue</div>
//               <div className="card-body">
//                 <h2 className="display-4">
//                   ₹
//                   {mockData.totalRevenue
//                     .reduce((sum, e) => sum + e.revenue, 0)
//                     .toLocaleString()}
//                 </h2>
//                 <div className="text-success">
//                   <i className="bi bi-arrow-up"></i> 12% vs last month
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Top 5 Buyers by Spend (Horizontal Bar) */}
//           <div className="col-md-3">
//             <div className="card h-100">
//               <div className="card-header">Top Spenders</div>
//               <div className="card-body">
//                 {mockData.events.map((event) => {
//                   const buyers =
//                     mockData.topBuyers.find((e) => e.eventId === event.id)
//                       ?.data || [];
//                   return (
//                     <div key={event.id} className="mb-4">
//                       <h6>{event.title}</h6>
//                       <Bar
//                         data={{
//                           labels: buyers.map((b) => b.name),
//                           datasets: [
//                             {
//                               label: "Total Spend (₹)",
//                               data: buyers.map((b) => b.spend),
//                               backgroundColor: "rgba(54, 162, 235, 0.7)",
//                             },
//                           ],
//                         }}
//                         options={{
//                           ...chartOptions,
//                           indexAxis: "y",
//                           plugins: { title: { text: "Top 3 Buyers" } },
//                         }}
//                       />
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>

//           {/* Win Ratio (Circular Progress) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">Win Ratios</div>
//               <div className="card-body">
//                 {mockData.events.map((event) => {
//                   const ratio =
//                     mockData.winRatio.find((e) => e.eventId === event.id)
//                       ?.ratio || 0;
//                   return (
//                     <div key={event.id} className="mb-4">
//                       <h6>{event.title}</h6>
//                       <div className="d-flex align-items-center">
//                         <div
//                           className="me-3"
//                           style={{
//                             width: "80px",
//                             height: "80px",
//                             position: "relative",
//                           }}
//                         >
//                           <svg viewBox="0 0 36 36" className="circular-chart">
//                             <path
//                               className="circle-bg"
//                               d="M18 2.0845
//                                 a 15.9155 15.9155 0 0 1 0 31.831
//                                 a 15.9155 15.9155 0 0 1 0 -31.831"
//                               fill="none"
//                               stroke="#eee"
//                               strokeWidth="2"
//                             />
//                             <path
//                               className="circle"
//                               strokeDasharray={`${ratio * 100}, 100`}
//                               d="M18 2.0845
//                                 a 15.9155 15.9155 0 0 1 0 31.831
//                                 a 15.9155 15.9155 0 0 1 0 -31.831"
//                               fill="none"
//                               stroke="rgba(75, 192, 192, 0.7)"
//                               strokeWidth="2"
//                               strokeLinecap="round"
//                             />
//                             <text
//                               x="18"
//                               y="20"
//                               className="percentage"
//                               textAnchor="middle"
//                             >
//                               {Math.round(ratio * 100)}%
//                             </text>
//                           </svg>
//                         </div>
//                         <div>
//                           <h5>Win Ratio</h5>
//                           <p className="mb-0">Cars won per bidder</p>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>

//           {/* Average Overbid % (Combo Chart) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">Overbid Analysis</div>
//               <div className="card-body">
//                 <Bar
//                   data={{
//                     labels: mockData.events.map((e) => e.title),
//                     datasets: [
//                       {
//                         type: "bar",
//                         label: "Sale Price (₹)",
//                         data: mockData.avgSalePrice.map((e) => e.sale),
//                         backgroundColor: "rgba(54, 162, 235, 0.7)",
//                       },
//                       {
//                         type: "line",
//                         label: "Overbid %",
//                         data: mockData.avgOverbid.map((e) => e.percent),
//                         borderColor: "rgba(255, 99, 132, 1)",
//                         backgroundColor: "rgba(255, 99, 132, 0.2)",
//                         yAxisID: "y1",
//                       },
//                     ],
//                   }}
//                   options={{
//                     ...chartOptions,
//                     scales: {
//                       y: { type: "linear", position: "left" },
//                       y1: {
//                         type: "linear",
//                         position: "right",
//                         grid: { drawOnChartArea: false },
//                       },
//                     },
//                     plugins: {
//                       title: { text: "Sale Price vs Overbid Percentage" },
//                     },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* 5. Lender Performance */}
//       <section>
//         <h2 className="mb-4">Lender Performance</h2>
//         <div className="row g-4">
//           {/* Events Hosted (Number Card) */}
//           <div className="col-md-3">
//             <div className="card h-100 text-center">
//               <div className="card-header">Total Events</div>
//               <div className="card-body">
//                 <h2 className="display-4">
//                   {mockData.lenderPerformance.reduce(
//                     (sum, l) => sum + l.eventsHosted,
//                     0
//                   )}
//                 </h2>
//                 <i
//                   className="bi bi-calendar-event"
//                   style={{ fontSize: "2rem", color: "rgba(54, 162, 235, 0.7)" }}
//                 ></i>
//               </div>
//             </div>
//           </div>

//           {/* Participation Rate (Radial Gauge) */}
//           <div className="col-md-3">
//             <div className="card h-100">
//               <div className="card-header">Participation Rate</div>
//               <div className="card-body text-center">
//                 {mockData.lenderPerformance.map((lender) => {
//                   const rate = lender.participationRate;
//                   return (
//                     <div key={lender.lenderId} className="mb-3">
//                       <h6>{lender.name}</h6>
//                       <div
//                         className="mx-auto"
//                         style={{
//                           width: "120px",
//                           height: "120px",
//                           position: "relative",
//                         }}
//                       >
//                         <PolarArea
//                           data={{
//                             labels: ["Rate"],
//                             datasets: [
//                               {
//                                 data: [rate, 100 - rate],
//                                 backgroundColor: [
//                                   "rgba(75, 192, 192, 0.7)",
//                                   "rgba(220, 220, 220, 0.5)",
//                                 ],
//                               },
//                             ],
//                           }}
//                           options={{
//                             scales: { r: { display: false } },
//                             plugins: {
//                               legend: { display: false },
//                               tooltip: { enabled: false },
//                             },
//                           }}
//                         />
//                         <div
//                           style={{
//                             position: "absolute",
//                             top: "50%",
//                             left: "50%",
//                             transform: "translate(-50%, -50%)",
//                             fontSize: "1.5rem",
//                           }}
//                         >
//                           {rate}%
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>

//           {/* Conversion Rate (Semi-Circle Gauge) */}
//           <div className="col-md-3">
//             <div className="card h-100">
//               <div className="card-header">Conversion Rate</div>
//               <div className="card-body">
//                 {mockData.lenderPerformance.map((lender) => {
//                   const rate = lender.conversionRate;
//                   return (
//                     <div key={lender.lenderId} className="mb-3">
//                       <h6>{lender.name}</h6>
//                       <div style={{ height: "100px", position: "relative" }}>
//                         <div
//                           style={{
//                             width: "100%",
//                             height: "50%",
//                             backgroundColor: "#f0f0f0",
//                             borderRadius: "100px 100px 0 0",
//                             overflow: "hidden",
//                             position: "relative",
//                           }}
//                         >
//                           <div
//                             style={{
//                               width: `${rate}%`,
//                               height: "100%",
//                               backgroundColor: "rgba(153, 102, 255, 0.7)",
//                               borderRadius: "100px 100px 0 0",
//                             }}
//                           ></div>
//                         </div>
//                         <div className="text-center mt-2">{rate}%</div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>

//           {/* Avg. Sale Price (Line Chart) */}
//           <div className="col-md-3">
//             <div className="card h-100">
//               <div className="card-header">Avg. Sale Price</div>
//               <div className="card-body">
//                 <Line
//                   data={{
//                     labels: mockData.lenderPerformance.map((l) => l.name),
//                     datasets: [
//                       {
//                         label: "Average Sale Price (₹)",
//                         data: mockData.lenderPerformance.map(
//                           (l) =>
//                             l.revenue /
//                             (mockData.regionPerformance.find(
//                               (r) => r.regionId === l.lenderId
//                             )?.carsSold || 1)
//                         ),
//                         borderColor: "rgba(255, 159, 64, 1)",
//                         backgroundColor: "rgba(255, 159, 64, 0.2)",
//                       },
//                     ],
//                   }}
//                   options={{
//                     ...chartOptions,
//                     plugins: { title: { text: "Per Car" } },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Total Revenue (Area Chart) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">Cumulative Revenue</div>
//               <div className="card-body">
//                 <Line
//                   data={{
//                     labels: mockData.lenderPerformance.map((l) => l.name),
//                     datasets: [
//                       {
//                         label: "Revenue (₹)",
//                         data: mockData.lenderPerformance.map((l) => l.revenue),
//                         borderColor: "rgba(75, 192, 192, 1)",
//                         backgroundColor: "rgba(75, 192, 192, 0.2)",
//                         fill: true,
//                       },
//                     ],
//                   }}
//                   options={{
//                     ...chartOptions,
//                     plugins: { title: { text: "Total Revenue by Lender" } },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Region-wise Performance (Map-like Bar) */}
//           <div className="col-md-6">
//             <div className="card h-100">
//               <div className="card-header">Regional Performance</div>
//               <div className="card-body">
//                 <Bar
//                   data={{
//                     labels: mockData.regions.map((r) => r.name),
//                     datasets: [
//                       {
//                         label: "Revenue (₹)",
//                         data: mockData.regionPerformance.map((r) => r.revenue),
//                         backgroundColor: mockData.regionPerformance.map(
//                           (r) =>
//                             `rgba(${Math.random() * 155 + 100}, ${
//                               Math.random() * 155 + 100
//                             }, ${Math.random() * 155 + 100}, 0.7)`
//                         ),
//                       },
//                       {
//                         label: "Cars Sold",
//                         data: mockData.regionPerformance.map((r) => r.carsSold),
//                         backgroundColor: mockData.regionPerformance.map(
//                           (r) =>
//                             `rgba(${Math.random() * 155}, ${
//                               Math.random() * 155 + 100
//                             }, ${Math.random() * 155}, 0.7)`
//                         ),
//                       },
//                     ],
//                   }}
//                   options={{
//                     ...chartOptions,
//                     plugins: { title: { text: "Revenue and Sales by Region" } },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Dashboard;


//==============================================================================

// import React, { useState } from 'react';
// import {
//   Bar,
//   Line,
//   Doughnut,
//   Pie,
//   Bubble,
//   PolarArea,
//   Scatter
// } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   PointElement,
//   LineElement,
//   ArcElement,
//   RadialLinearScale,
//   TimeScale,
//   TimeSeriesScale
// } from 'chart.js';

// // Register ChartJS components
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   PointElement,
//   LineElement,
//   ArcElement,
//   RadialLinearScale,
//   TimeScale,
//   TimeSeriesScale
// );

// // Color Palette - Professional Blue/Gray theme with accent colors
// const colors = {
//   primary: '#1e40af',      // Blue
//   secondary: '#64748b',    // Slate gray
//   success: '#059669',      // Green
//   warning: '#d97706',      // Orange
//   danger: '#dc2626',       // Red
//   info: '#0891b2',         // Cyan
//   light: '#f8fafc',        // Very light gray
//   dark: '#0f172a',         // Very dark blue
//   accent1: '#7c3aed',      // Purple
//   accent2: '#db2777',      // Pink
//   neutral: '#6b7280'       // Medium gray
// };

// // Chart color arrays for consistency
// const chartColors = {
//   primary: [colors.primary, colors.secondary, colors.success, colors.warning, colors.info, colors.accent1],
//   gradients: [
//     `${colors.primary}80`,
//     `${colors.secondary}80`, 
//     `${colors.success}80`,
//     `${colors.warning}80`,
//     `${colors.info}80`,
//     `${colors.accent1}80`
//   ]
// };

// // Mock Data (Same as original)
// const mockData = {
//   events: [
//     { id: 1, title: 'Mumbai Auto Expo', start: '2025-08-01T09:00:00', end: '2025-08-01T17:00:00' },
//     { id: 2, title: 'Delhi Car Auction', start: '2025-08-05T10:00:00', end: '2025-08-05T18:00:00' }
//   ],
//   mappedUsers: [
//     { eventId: 1, count: 120 },
//     { eventId: 2, count: 95 }
//   ],
//   registeredUsers: [
//     { eventId: 1, count: 85 },
//     { eventId: 2, count: 70 }
//   ],
//   activeBidders: [
//     { eventId: 1, count: 60 },
//     { eventId: 2, count: 50 }
//   ],
//   carsMapped: [
//     { eventId: 1, count: 40 },
//     { eventId: 2, count: 30 }
//   ],
//   carsSold: [
//     { eventId: 1, count: 32 },
//     { eventId: 2, count: 22 }
//   ],
//   carsNoBids: [
//     { eventId: 1, count: 5 },
//     { eventId: 2, count: 3 }
//   ],
//   carsMultipleBidders: [
//     { eventId: 1, count: 12, maxBid: 150000 },
//     { eventId: 2, count: 8, maxBid: 120000 }
//   ],
//   avgSalePrice: [
//     { eventId: 1, start: 500000, sale: 580000 },
//     { eventId: 2, start: 450000, sale: 520000 }
//   ],
//   totalBids: [
//     { eventId: 1, count: 450 },
//     { eventId: 2, count: 380 }
//   ],
//   bidActivity: [
//     { eventId: 1, bids: [10, 30, 50, 80, 100, 80, 60, 40] },
//     { eventId: 2, bids: [5, 25, 40, 70, 90, 70, 50, 30] }
//   ],
//   maxBidPerUser: [
//     { eventId: 1, data: { 'Dealer A': 850000, 'Dealer B': 720000, 'Dealer C': 680000 } },
//     { eventId: 2, data: { 'Dealer X': 650000, 'Dealer Y': 580000, 'Dealer Z': 520000 } }
//   ],
//   bidTimes: [
//     { eventId: 1, earliest: '2025-08-01T09:15:00', latest: '2025-08-01T16:45:00' },
//     { eventId: 2, earliest: '2025-08-05T10:30:00', latest: '2025-08-05T17:50:00' }
//   ],
//   carsWonPerBuyer: [
//     { eventId: 1, data: { 'Dealer A': 8, 'Dealer B': 6, 'Dealer C': 5 } },
//     { eventId: 2, data: { 'Dealer X': 6, 'Dealer Y': 5, 'Dealer Z': 4 } }
//   ],
//   totalRevenue: [
//     { eventId: 1, revenue: 18560000 },
//     { eventId: 2, revenue: 11440000 }
//   ],
//   topBuyers: [
//     { eventId: 1, data: [
//       { name: 'Dealer A', spend: 6800000 },
//       { name: 'Dealer B', spend: 4200000 },
//       { name: 'Dealer C', spend: 3500000 }
//     ]},
//     { eventId: 2, data: [
//       { name: 'Dealer X', spend: 4500000 },
//       { name: 'Dealer Y', spend: 3800000 },
//       { name: 'Dealer Z', spend: 3100000 }
//     ]}
//   ],
//   winRatio: [
//     { eventId: 1, ratio: 0.75 },
//     { eventId: 2, ratio: 0.68 }
//   ],
//   avgOverbid: [
//     { eventId: 1, percent: 16 },
//     { eventId: 2, percent: 14 }
//   ],
//   regions: [
//     { id: 1, name: 'North' },
//     { id: 2, name: 'South' },
//     { id: 3, name: 'East' },
//     { id: 4, name: 'West' }
//   ],
//   regionPerformance: [
//     { regionId: 1, revenue: 12000000, carsSold: 25 },
//     { regionId: 2, revenue: 9500000, carsSold: 20 },
//     { regionId: 3, revenue: 8000000, carsSold: 15 },
//     { regionId: 4, revenue: 6000000, carsSold: 10 }
//   ],
//   lenderPerformance: [
//     { lenderId: 1, name: 'Premier Motors', eventsHosted: 3, revenue: 25000000, participationRate: 82, conversionRate: 78 },
//     { lenderId: 2, name: 'Elite Cars', eventsHosted: 2, revenue: 18000000, participationRate: 75, conversionRate: 70 }
//   ]
// };

// const Dashboard = () => {
//   const [activeTab, setActiveTab] = useState('overview');

//   // Helper functions
//   const getEventDuration = (start, end) => {
//     const startTime = new Date(start);
//     const endTime = new Date(end);
//     return (endTime - startTime) / (1000 * 60);
//   };

//   const calculateBiddingIntensity = (eventId) => {
//     const bids = mockData.totalBids.find(e => e.eventId === eventId)?.count || 0;
//     const event = mockData.events.find(e => e.id === eventId);
//     const duration = event ? getEventDuration(event.start, event.end) : 1;
//     return (bids / duration).toFixed(2);
//   };

//   const formatCurrency = (amount) => {
//     return `₹${(amount / 1000000).toFixed(1)}M`;
//   };

//   // Enhanced chart options with consistent styling
//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: { 
//         position: 'top',
//         labels: {
//           font: { size: 12, family: 'Inter, sans-serif' },
//           usePointStyle: true,
//           padding: 20
//         }
//       },
//       title: { 
//         display: true, 
//         font: { size: 14, weight: '600', family: 'Inter, sans-serif' },
//         color: colors.dark,
//         padding: { bottom: 20 }
//       }
//     },
//     scales: {
//       x: {
//         grid: { color: '#e2e8f0', borderWidth: 0 },
//         ticks: { font: { size: 11 }, color: colors.neutral }
//       },
//       y: {
//         grid: { color: '#e2e8f0', borderWidth: 0 },
//         ticks: { font: { size: 11 }, color: colors.neutral }
//       }
//     }
//   };

//   // Metric Card Component
//   const MetricCard = ({ title, value, subtitle, icon, color = colors.primary, trend }) => (
//     <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow duration-200">
//       <div className="flex items-center justify-between mb-4">
//         <div className={`p-3 rounded-lg bg-opacity-10`} style={{ backgroundColor: `${color}20` }}>
//           <div className="text-2xl" style={{ color }}>{icon}</div>
//         </div>
//         {trend && (
//           <div className={`text-sm font-medium ${trend > 0 ? 'text-green-600' : 'text-red-600'}`}>
//             {trend > 0 ? '↗' : '↘'} {Math.abs(trend)}%
//           </div>
//         )}
//       </div>
//       <h3 className="text-2xl font-bold text-gray-900 mb-1">{value}</h3>
//       <p className="text-gray-600 text-sm mb-1">{title}</p>
//       {subtitle && <p className="text-gray-400 text-xs">{subtitle}</p>}
//     </div>
//   );

//   // Chart Card Component
//   const ChartCard = ({ title, children, height = "300px" }) => (
//     <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow duration-200">
//       <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
//       <div style={{ height }}>{children}</div>
//     </div>
//   );

//   return (
//     <div className="min-h-screen" style={{ backgroundColor: colors.light }}>
//       {/* Header */}
//       <div className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-10">
//         <div className="max-w-7xl mx-auto px-6 py-4">
//           <div className="flex items-center justify-between">
//             <div>
//               <h1 className="text-3xl font-bold text-gray-900">Auction Dashboard</h1>
//               <p className="text-gray-600 mt-1">Real-time auction analytics and insights</p>
//             </div>
//             <div className="flex space-x-2">
//               <button 
//                 onClick={() => setActiveTab('overview')}
//                 className={`px-4 py-2 rounded-lg font-medium transition-colors ${
//                   activeTab === 'overview' 
//                     ? 'bg-blue-100 text-blue-700' 
//                     : 'text-gray-600 hover:text-gray-900'
//                 }`}
//               >
//                 Overview
//               </button>
//               <button 
//                 onClick={() => setActiveTab('detailed')}
//                 className={`px-4 py-2 rounded-lg font-medium transition-colors ${
//                   activeTab === 'detailed' 
//                     ? 'bg-blue-100 text-blue-700' 
//                     : 'text-gray-600 hover:text-gray-900'
//                 }`}
//               >
//                 Detailed View
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="max-w-7xl mx-auto px-6 py-8">
//         {/* Key Metrics Overview */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
//           <MetricCard
//             title="Total Revenue"
//             value={formatCurrency(mockData.totalRevenue.reduce((sum, e) => sum + e.revenue, 0))}
//             subtitle="Across all events"
//             icon="💰"
//             color={colors.success}
//             trend={12}
//           />
//           <MetricCard
//             title="Cars Sold"
//             value={mockData.carsSold.reduce((sum, e) => sum + e.count, 0)}
//             subtitle="Out of 70 total cars"
//             icon="🚗"
//             color={colors.primary}
//             trend={8}
//           />
//           <MetricCard
//             title="Active Bidders"
//             value={mockData.activeBidders.reduce((sum, e) => sum + e.count, 0)}
//             subtitle="Registered participants"
//             icon="👥"
//             color={colors.info}
//             trend={5}
//           />
//           <MetricCard
//             title="Total Bids"
//             value={mockData.totalBids.reduce((sum, e) => sum + e.count, 0)}
//             subtitle="Bid activity"
//             icon="⚡"
//             color={colors.warning}
//             trend={-2}
//           />
//         </div>

//         {/* Main Charts Grid */}
//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mb-8">
//           {/* Participation Overview */}
//           <div className="lg:col-span-8">
//             <ChartCard title="Event Participation Overview" height="350px">
//               <Bar
//                 data={{
//                   labels: mockData.events.map(e => e.title),
//                   datasets: [
//                     {
//                       label: "Mapped Users",
//                       data: mockData.mappedUsers.map(e => e.count),
//                       backgroundColor: chartColors.gradients[0],
//                       borderColor: chartColors.primary[0],
//                       borderWidth: 2,
//                     },
//                     {
//                       label: "Registered",
//                       data: mockData.registeredUsers.map(e => e.count),
//                       backgroundColor: chartColors.gradients[1],
//                       borderColor: chartColors.primary[1],
//                       borderWidth: 2,
//                     },
//                     {
//                       label: "Active Bidders",
//                       data: mockData.activeBidders.map(e => e.count),
//                       backgroundColor: chartColors.gradients[2],
//                       borderColor: chartColors.primary[2],
//                       borderWidth: 2,
//                     }
//                   ]
//                 }}
//                 options={{
//                   ...chartOptions,
//                   plugins: {
//                     ...chartOptions.plugins,
//                     title: { ...chartOptions.plugins.title, text: "User Engagement Funnel" }
//                   }
//                 }}
//               />
//             </ChartCard>
//           </div>

//           {/* Sales Performance */}
//           <div className="lg:col-span-4">
//             <ChartCard title="Sales Performance" height="350px">
//               <Doughnut
//                 data={{
//                   labels: ["Sold", "Unsold", "No Bids"],
//                   datasets: [{
//                     data: [
//                       mockData.carsSold.reduce((sum, e) => sum + e.count, 0),
//                       mockData.carsMapped.reduce((sum, e) => sum + e.count, 0) - 
//                       mockData.carsSold.reduce((sum, e) => sum + e.count, 0),
//                       mockData.carsNoBids.reduce((sum, e) => sum + e.count, 0)
//                     ],
//                     backgroundColor: [colors.success, colors.warning, colors.danger],
//                     borderWidth: 0,
//                     cutout: '65%'
//                   }]
//                 }}
//                 options={{
//                   ...chartOptions,
//                   plugins: {
//                     ...chartOptions.plugins,
//                     legend: { position: 'bottom' }
//                   }
//                 }}
//               />
//             </ChartCard>
//           </div>
//         </div>

//         {/* Price Analysis */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
//           <ChartCard title="Price Analysis" height="300px">
//             <Line
//               data={{
//                 labels: mockData.events.map(e => e.title),
//                 datasets: [
//                   {
//                     label: "Start Price",
//                     data: mockData.avgSalePrice.map(e => e.start),
//                     borderColor: colors.secondary,
//                     backgroundColor: `${colors.secondary}20`,
//                     borderWidth: 3,
//                     fill: false,
//                     tension: 0.4
//                   },
//                   {
//                     label: "Final Sale Price",
//                     data: mockData.avgSalePrice.map(e => e.sale),
//                     borderColor: colors.success,
//                     backgroundColor: `${colors.success}20`,
//                     borderWidth: 3,
//                     fill: false,
//                     tension: 0.4
//                   }
//                 ]
//               }}
//               options={{
//                 ...chartOptions,
//                 plugins: {
//                   ...chartOptions.plugins,
//                   title: { ...chartOptions.plugins.title, text: "Average Prices by Event" }
//                 }
//               }}
//             />
//           </ChartCard>

//           <ChartCard title="Bid Activity Timeline" height="300px">
//             <Line
//               data={{
//                 labels: ["9AM", "10AM", "11AM", "12PM", "1PM", "2PM", "3PM", "4PM"],
//                 datasets: mockData.bidActivity.map((activity, i) => ({
//                   label: mockData.events[i].title,
//                   data: activity.bids,
//                   borderColor: chartColors.primary[i],
//                   backgroundColor: chartColors.gradients[i],
//                   borderWidth: 3,
//                   fill: true,
//                   tension: 0.4
//                 }))
//               }}
//               options={{
//                 ...chartOptions,
//                 plugins: {
//                   ...chartOptions.plugins,
//                   title: { ...chartOptions.plugins.title, text: "Hourly Bid Activity" }
//                 }
//               }}
//             />
//           </ChartCard>
//         </div>

//         {/* Regional Performance */}
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
//           <ChartCard title="Regional Revenue" height="300px">
//             <Bar
//               data={{
//                 labels: mockData.regions.map(r => r.name),
//                 datasets: [{
//                   label: "Revenue (₹M)",
//                   data: mockData.regionPerformance.map(r => r.revenue / 1000000),
//                   backgroundColor: chartColors.primary.map(color => `${color}80`),
//                   borderColor: chartColors.primary,
//                   borderWidth: 2
//                 }]
//               }}
//               options={{
//                 ...chartOptions,
//                 indexAxis: 'y',
//                 plugins: {
//                   ...chartOptions.plugins,
//                   title: { ...chartOptions.plugins.title, text: "Revenue by Region" }
//                 }
//               }}
//             />
//           </ChartCard>

//           <ChartCard title="Top Buyers" height="300px">
//             <div className="space-y-4">
//               {mockData.events.map(event => {
//                 const buyers = mockData.topBuyers.find(e => e.eventId === event.id)?.data || [];
//                 return (
//                   <div key={event.id}>
//                     <h4 className="font-medium text-gray-700 mb-2">{event.title}</h4>
//                     {buyers.slice(0, 3).map((buyer, i) => (
//                       <div key={buyer.name} className="flex items-center justify-between py-2">
//                         <div className="flex items-center space-x-3">
//                           <div 
//                             className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-medium"
//                             style={{ backgroundColor: chartColors.primary[i] }}
//                           >
//                             {i + 1}
//                           </div>
//                           <span className="text-sm font-medium text-gray-900">{buyer.name}</span>
//                         </div>
//                         <span className="text-sm text-gray-600">{formatCurrency(buyer.spend)}</span>
//                       </div>
//                     ))}
//                   </div>
//                 );
//               })}
//             </div>
//           </ChartCard>

//           <ChartCard title="Win Ratios" height="300px">
//             <div className="space-y-6">
//               {mockData.events.map(event => {
//                 const ratio = mockData.winRatio.find(e => e.eventId === event.id)?.ratio || 0;
//                 return (
//                   <div key={event.id} className="text-center">
//                     <h4 className="font-medium text-gray-700 mb-3">{event.title}</h4>
//                     <div className="relative w-24 h-24 mx-auto">
//                       <svg className="w-24 h-24 transform -rotate-90" viewBox="0 0 36 36">
//                         <path
//                           d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
//                           fill="none"
//                           stroke="#e5e7eb"
//                           strokeWidth="3"
//                         />
//                         <path
//                           d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
//                           fill="none"
//                           stroke={colors.primary}
//                           strokeWidth="3"
//                           strokeDasharray={`${ratio * 100}, 100`}
//                           strokeLinecap="round"
//                         />
//                       </svg>
//                       <div className="absolute inset-0 flex items-center justify-center">
//                         <span className="text-lg font-bold text-gray-900">{Math.round(ratio * 100)}%</span>
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </ChartCard>
//         </div>

//         {/* Detailed Analytics */}
//         {activeTab === 'detailed' && (
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//             <ChartCard title="Bidding Intensity" height="300px">
//               <Bar
//                 data={{
//                   labels: mockData.events.map(e => e.title),
//                   datasets: [{
//                     label: "Bids per Minute",
//                     data: mockData.events.map(e => calculateBiddingIntensity(e.id)),
//                     backgroundColor: mockData.events.map((e, i) => {
//                       const intensity = parseFloat(calculateBiddingIntensity(e.id));
//                       return intensity > 1 ? colors.danger : intensity > 0.5 ? colors.warning : colors.success;
//                     }),
//                     borderWidth: 0
//                   }]
//                 }}
//                 options={chartOptions}
//               />
//             </ChartCard>

//             <ChartCard title="Lender Performance" height="300px">
//               <div className="grid grid-cols-1 gap-4">
//                 {mockData.lenderPerformance.map(lender => (
//                   <div key={lender.lenderId} className="p-4 bg-gray-50 rounded-lg">
//                     <h4 className="font-semibold text-gray-900 mb-2">{lender.name}</h4>
//                     <div className="grid grid-cols-3 gap-4 text-sm">
//                       <div className="text-center">
//                         <div className="text-lg font-bold text-blue-600">{lender.eventsHosted}</div>
//                         <div className="text-gray-600">Events</div>
//                       </div>
//                       <div className="text-center">
//                         <div className="text-lg font-bold text-green-600">{lender.participationRate}%</div>
//                         <div className="text-gray-600">Participation</div>
//                       </div>
//                       <div className="text-center">
//                         <div className="text-lg font-bold text-purple-600">{lender.conversionRate}%</div>
//                         <div className="text-gray-600">Conversion</div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </ChartCard>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Dashboard;


//=========================================================

import React, { useState } from 'react';
import {
  Bar,
  Line,
  Doughnut,
  Pie,
  Bubble,
  PolarArea,
  Scatter
} from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  ArcElement,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale
} from 'chart.js';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  ArcElement,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale
);

// Color Palette
const colors = {
  primary: '#2563eb',      // Blue
  secondary: '#7c3aed',    // Purple
  success: '#059669',      // Green
  warning: '#d97706',      // Orange
  danger: '#dc2626',       // Red
  info: '#0891b2',         // Cyan
  light: '#f8fafc',        // Light gray
  dark: '#1e293b',         // Dark gray
  muted: '#64748b',        // Medium gray
  background: '#ffffff',
  cardBg: '#ffffff',
  border: '#e2e8f0'
};

// Mock Data (same as before)
const mockData = {
  events: [
    { id: 1, title: 'Mumbai Auto Expo', start: '2025-08-01T09:00:00', end: '2025-08-01T17:00:00' },
    { id: 2, title: 'Delhi Car Auction', start: '2025-08-05T10:00:00', end: '2025-08-05T18:00:00' }
  ],
  mappedUsers: [
    { eventId: 1, count: 120 },
    { eventId: 2, count: 95 }
  ],
  registeredUsers: [
    { eventId: 1, count: 85 },
    { eventId: 2, count: 70 }
  ],
  activeBidders: [
    { eventId: 1, count: 60 },
    { eventId: 2, count: 50 }
  ],
  carsMapped: [
    { eventId: 1, count: 40 },
    { eventId: 2, count: 30 }
  ],
  carsSold: [
    { eventId: 1, count: 32 },
    { eventId: 2, count: 22 }
  ],
  carsNoBids: [
    { eventId: 1, count: 5 },
    { eventId: 2, count: 3 }
  ],
  carsMultipleBidders: [
    { eventId: 1, count: 12, maxBid: 150000 },
    { eventId: 2, count: 8, maxBid: 120000 }
  ],
  avgSalePrice: [
    { eventId: 1, start: 500000, sale: 580000 },
    { eventId: 2, start: 450000, sale: 520000 }
  ],
  totalBids: [
    { eventId: 1, count: 450 },
    { eventId: 2, count: 380 }
  ],
  bidActivity: [
    { eventId: 1, bids: [10, 30, 50, 80, 100, 80, 60, 40] },
    { eventId: 2, bids: [5, 25, 40, 70, 90, 70, 50, 30] }
  ],
  maxBidPerUser: [
    { eventId: 1, data: { 'Dealer A': 850000, 'Dealer B': 720000, 'Dealer C': 680000 } },
    { eventId: 2, data: { 'Dealer X': 650000, 'Dealer Y': 580000, 'Dealer Z': 520000 } }
  ],
  bidTimes: [
    { eventId: 1, earliest: '2025-08-01T09:15:00', latest: '2025-08-01T16:45:00' },
    { eventId: 2, earliest: '2025-08-05T10:30:00', latest: '2025-08-05T17:50:00' }
  ],
  carsWonPerBuyer: [
    { eventId: 1, data: { 'Dealer A': 8, 'Dealer B': 6, 'Dealer C': 5 } },
    { eventId: 2, data: { 'Dealer X': 6, 'Dealer Y': 5, 'Dealer Z': 4 } }
  ],
  totalRevenue: [
    { eventId: 1, revenue: 18560000 },
    { eventId: 2, revenue: 11440000 }
  ],
  topBuyers: [
    { eventId: 1, data: [
      { name: 'Dealer A', spend: 6800000 },
      { name: 'Dealer B', spend: 4200000 },
      { name: 'Dealer C', spend: 3500000 }
    ]},
    { eventId: 2, data: [
      { name: 'Dealer X', spend: 4500000 },
      { name: 'Dealer Y', spend: 3800000 },
      { name: 'Dealer Z', spend: 3100000 }
    ]}
  ],
  winRatio: [
    { eventId: 1, ratio: 0.75 },
    { eventId: 2, ratio: 0.68 }
  ],
  avgOverbid: [
    { eventId: 1, percent: 16 },
    { eventId: 2, percent: 14 }
  ],
  regions: [
    { id: 1, name: 'North' },
    { id: 2, name: 'South' },
    { id: 3, name: 'East' },
    { id: 4, name: 'West' }
  ],
  regionPerformance: [
    { regionId: 1, revenue: 12000000, carsSold: 25 },
    { regionId: 2, revenue: 9500000, carsSold: 20 },
    { regionId: 3, revenue: 8000000, carsSold: 15 },
    { regionId: 4, revenue: 6000000, carsSold: 10 }
  ],
  lenderPerformance: [
    { lenderId: 1, name: 'Premier Motors', eventsHosted: 3, revenue: 25000000, participationRate: 82, conversionRate: 78 },
    { lenderId: 2, name: 'Elite Cars', eventsHosted: 2, revenue: 18000000, participationRate: 75, conversionRate: 70 }
  ]
};

const Dashboard = () => {
  const [selectedTab, setSelectedTab] = useState('overview');

  // Styles
  const styles = {
    container: {
      background: `linear-gradient(135deg, ${colors.light} 0%, #f1f5f9 100%)`,
      minHeight: '100vh',
      padding: '0',
      margin: '0',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif'
    },
    header: {
      background: `linear-gradient(135deg, #ee373b 0%, #f15922 100%)`,
      color: 'white',
      padding: '2rem 0',
      textAlign: 'center',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
    },
    nav: {
      background: colors.cardBg,
      padding: '1rem 2rem',
      borderBottom: `1px solid ${colors.border}`,
      display: 'flex',
      gap: '1rem',
      overflowX: 'auto'
    },
    navButton: {
      background: 'transparent',
      border: 'none',
      padding: '0.75rem 1.5rem',
      borderRadius: '8px',
      cursor: 'pointer',
      fontWeight: '500',
      transition: 'all 0.2s',
      whiteSpace: 'nowrap'
    },
    activeNavButton: {
      background: "#ee373b",
      color: 'white'
    },
    inactiveNavButton: {
      color: colors.muted
    },
    content: {
      padding: '2rem',
      maxWidth: '1400px',
      margin: '0 auto'
    },
    section: {
      marginBottom: '3rem'
    },
    sectionTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      color: colors.dark,
      marginBottom: '1.5rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem'
    },
    grid: {
      display: 'grid',
      gap: '1.5rem'
    },
    gridCols2: {
      gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))'
    },
    gridCols3: {
      gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))'
    },
    gridCols4: {
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))'
    },
    card: {
      background: colors.cardBg,
      borderRadius: '12px',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      border: `1px solid ${colors.border}`,
      overflow: 'hidden',
      transition: 'transform 0.2s, box-shadow 0.2s'
    },
    cardHover: {
      ':hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
      }
    },
    cardHeader: {
      padding: '1rem 1.5rem',
      background: colors.light,
      borderBottom: `1px solid ${colors.border}`,
      fontWeight: '600',
      color: colors.dark
    },
    cardBody: {
      padding: '1.5rem'
    },
    kpiCard: {
      textAlign: 'center',
      padding: '2rem 1.5rem'
    },
    kpiNumber: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: colors.primary,
      marginBottom: '0.5rem'
    },
    kpiLabel: {
      color: colors.muted,
      fontSize: '0.875rem',
      fontWeight: '500'
    },
    progressBar: {
      width: '100%',
      height: '8px',
      background: colors.light,
      borderRadius: '4px',
      overflow: 'hidden',
      marginTop: '1rem'
    },
    progressFill: {
      height: '100%',
      background: `linear-gradient(90deg, ${colors.primary}, ${colors.secondary})`,
      borderRadius: '4px',
      transition: 'width 0.3s ease'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse'
    },
    th: {
      padding: '0.75rem 1rem',
      background: colors.light,
      fontWeight: '600',
      color: colors.dark,
      borderBottom: `1px solid ${colors.border}`,
      textAlign: 'left'
    },
    td: {
      padding: '0.75rem 1rem',
      borderBottom: `1px solid ${colors.border}`,
      color: colors.dark
    },
    badge: {
      padding: '0.25rem 0.75rem',
      borderRadius: '6px',
      fontSize: '0.75rem',
      fontWeight: '500'
    },
    successBadge: {
      background: `${colors.success}20`,
      color: colors.success
    },
    warningBadge: {
      background: `${colors.warning}20`,
      color: colors.warning
    }
  };

  // Helper functions
  const getEventDuration = (start, end) => {
    const startTime = new Date(start);
    const endTime = new Date(end);
    return (endTime - startTime) / (1000 * 60);
  };

  const calculateBiddingIntensity = (eventId) => {
    const bids = mockData.totalBids.find(e => e.eventId === eventId)?.count || 0;
    const event = mockData.events.find(e => e.id === eventId);
    const duration = event ? getEventDuration(event.start, event.end) : 1;
    return (bids / duration).toFixed(2);
  };

  // Chart options with consistent styling
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { 
        position: 'top',
        labels: {
          color: colors.dark,
          usePointStyle: true,
          padding: 20
        }
      },
      title: { 
        display: true, 
        font: { 
          size: 14,
          weight: '600'
        },
        color: colors.dark,
        padding: 20
      }
    },
    scales: {
      x: {
        grid: {
          color: colors.border
        },
        ticks: {
          color: colors.muted
        }
      },
      y: {
        grid: {
          color: colors.border
        },
        ticks: {
          color: colors.muted
        }
      }
    }
  };

  // Chart color schemes
  const getChartColors = (count = 1) => {
    const colorScheme = [colors.primary, colors.secondary, colors.success, colors.warning, colors.info, colors.danger];
    return Array.from({length: count}, (_, i) => colorScheme[i % colorScheme.length]);
  };

  const Card = ({ title, children, className = '' }) => (
    <div style={{...styles.card, ...styles.cardHover}} className={className}>
      <div style={styles.cardHeader}>{title}</div>
      <div style={styles.cardBody}>
        {children}
      </div>
    </div>
  );

  const KPICard = ({ title, value, subtitle, color = colors.primary, icon }) => (
    <div style={{...styles.card, ...styles.kpiCard}}>
      {icon && <div style={{fontSize: '2rem', marginBottom: '1rem'}}>{icon}</div>}
      <div style={{...styles.kpiNumber, color}}>{value}</div>
      <div style={styles.kpiLabel}>{title}</div>
      {subtitle && <div style={{...styles.kpiLabel, marginTop: '0.5rem'}}>{subtitle}</div>}
    </div>
  );

  const OverviewTab = () => (
    <div>
      {/* KPI Cards */}
      <div style={{...styles.grid, ...styles.gridCols4, marginBottom: '2rem'}}>
        <KPICard 
          title="Total Revenue" 
          value={`₹${mockData.totalRevenue.reduce((sum, e) => sum + e.revenue, 0).toLocaleString()}`}
          subtitle="↗ 12% vs last month"
          color={colors.success}
          icon="💰"
        />
        <KPICard 
          title="Total Cars Sold" 
          value={mockData.carsSold.reduce((sum, car) => sum + car.count, 0)}
          subtitle="↗ 8% vs last month"
          color={colors.primary}
          icon="🚗"
        />
        <KPICard 
          title="Active Bidders" 
          value={mockData.activeBidders.reduce((sum, bidder) => sum + bidder.count, 0)}
          subtitle="↗ 15% vs last month"
          color={colors.secondary}
          icon="👥"
        />
        <KPICard 
          title="Total Bids" 
          value={mockData.totalBids.reduce((sum, bid) => sum + bid.count, 0)}
          subtitle="↗ 22% vs last month"
          color={colors.warning}
          icon="🔨"
        />
      </div>

      {/* Main Charts */}
      <div style={{...styles.grid, ...styles.gridCols2}}>
        <Card title="Revenue by Event">
          <div style={{height: '300px'}}>
            <Bar
              data={{
                labels: mockData.events.map(e => e.title),
                datasets: [{
                  label: "Revenue (₹)",
                  data: mockData.totalRevenue.map(e => e.revenue),
                  backgroundColor: getChartColors(2).map(color => color + '80'),
                  borderColor: getChartColors(2),
                  borderWidth: 2
                }]
              }}
              options={{...chartOptions, plugins: {...chartOptions.plugins, title: {text: ""}}}}
            />
          </div>
        </Card>

        <Card title="User Engagement">
          <div style={{height: '300px'}}>
            <Bar
              data={{
                labels: mockData.events.map(e => e.title),
                datasets: [
                  {
                    label: "Mapped Users",
                    data: mockData.mappedUsers.map(e => e.count),
                    backgroundColor: colors.info + '80',
                    borderColor: colors.info,
                    borderWidth: 2
                  },
                  {
                    label: "Registered Users",
                    data: mockData.registeredUsers.map(e => e.count),
                    backgroundColor: colors.success + '80',
                    borderColor: colors.success,
                    borderWidth: 2
                  },
                  {
                    label: "Active Bidders",
                    data: mockData.activeBidders.map(e => e.count),
                    backgroundColor: colors.primary + '80',
                    borderColor: colors.primary,
                    borderWidth: 2
                  }
                ]
              }}
              options={chartOptions}
            />
          </div>
        </Card>

        <Card title="Cars Performance">
          <div style={{height: '300px'}}>
            <Doughnut
              data={{
                labels: ["Sold", "Unsold"],
                datasets: [{
                  data: [
                    mockData.carsSold.reduce((sum, car) => sum + car.count, 0),
                    mockData.carsMapped.reduce((sum, car) => sum + car.count, 0) - mockData.carsSold.reduce((sum, car) => sum + car.count, 0)
                  ],
                  backgroundColor: [colors.success + '80', colors.danger + '80'],
                  borderColor: [colors.success, colors.danger],
                  borderWidth: 2
                }]
              }}
              options={chartOptions}
            />
          </div>
        </Card>

        <Card title="Bid Activity Timeline">
          <div style={{height: '300px'}}>
            <Line
              data={{
                labels: ["9AM", "10AM", "11AM", "12PM", "1PM", "2PM", "3PM", "4PM"],
                datasets: mockData.bidActivity.map((activity, i) => ({
                  label: mockData.events[i].title,
                  data: activity.bids,
                  borderColor: getChartColors(2)[i],
                  backgroundColor: getChartColors(2)[i] + '20',
                  fill: true,
                  tension: 0.4
                }))
              }}
              options={chartOptions}
            />
          </div>
        </Card>
      </div>
    </div>
  );

  const ParticipationTab = () => (
    <div>
      <div style={{...styles.grid, ...styles.gridCols3}}>
        <Card title="User Registration Progress">
          {mockData.events.map(event => {
            const regUsers = mockData.registeredUsers.find(e => e.eventId === event.id)?.count || 0;
            const mappedUsers = mockData.mappedUsers.find(e => e.eventId === event.id)?.count || 1;
            const ratio = ((regUsers / mappedUsers) * 100).toFixed(1);
            return (
              <div key={event.id} style={{marginBottom: '1.5rem'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem'}}>
                  <span style={{fontWeight: '500', color: colors.dark}}>{event.title}</span>
                  <span style={{color: colors.primary, fontWeight: '600'}}>{ratio}%</span>
                </div>
                <div style={styles.progressBar}>
                  <div style={{...styles.progressFill, width: `${ratio}%`}}></div>
                </div>
                <div style={{fontSize: '0.75rem', color: colors.muted, marginTop: '0.25rem'}}>
                  {regUsers} of {mappedUsers} users registered
                </div>
              </div>
            );
          })}
        </Card>

        <Card title="Bidder Activity Status">
          <div style={{height: '250px'}}>
            <Doughnut
              data={{
                labels: ["Active Bidders", "Inactive Users"],
                datasets: [{
                  data: [
                    mockData.activeBidders.reduce((sum, bidder) => sum + bidder.count, 0),
                    mockData.registeredUsers.reduce((sum, user) => sum + user.count, 0) - mockData.activeBidders.reduce((sum, bidder) => sum + bidder.count, 0)
                  ],
                  backgroundColor: [colors.success + '80', colors.muted + '80'],
                  borderColor: [colors.success, colors.muted],
                  borderWidth: 2
                }]
              }}
              options={chartOptions}
            />
          </div>
        </Card>

        <Card title="Average Bids per User">
          {mockData.events.map(event => {
            const bids = mockData.totalBids.find(e => e.eventId === event.id)?.count || 0;
            const active = mockData.activeBidders.find(e => e.eventId === event.id)?.count || 1;
            const avg = (bids / active).toFixed(1);
            return (
              <div key={event.id} style={{...styles.kpiCard, padding: '1.5rem'}}>
                <div style={{...styles.kpiNumber, fontSize: '2rem'}}>{avg}</div>
                <div style={styles.kpiLabel}>{event.title}</div>
              </div>
            );
          })}
        </Card>
      </div>
    </div>
  );

  const WinMetricsTab = () => (
    <div>
      <div style={{...styles.grid, ...styles.gridCols2}}>
        <Card title="Top Buyers Leaderboard">
          {mockData.events.map(event => {
            const buyers = mockData.carsWonPerBuyer.find(e => e.eventId === event.id)?.data || {};
            return (
              <div key={event.id} style={{marginBottom: '2rem'}}>
                <h4 style={{color: colors.primary, marginBottom: '1rem'}}>{event.title}</h4>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>Rank</th>
                      <th style={styles.th}>Buyer</th>
                      <th style={styles.th}>Cars Won</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(buyers)
                      .sort((a, b) => b[1] - a[1])
                      .map(([name, count], i) => (
                        <tr key={name}>
                          <td style={styles.td}>
                            <span style={{...styles.badge, ...(i === 0 ? styles.successBadge : styles.warningBadge)}}>
                              #{i + 1}
                            </span>
                          </td>
                          <td style={styles.td}>{name}</td>
                          <td style={{...styles.td, fontWeight: '600', color: colors.primary}}>{count}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            );
          })}
        </Card>

        <Card title="Revenue by Top Spenders">
          <div style={{height: '400px'}}>
            <Bar
              data={{
                labels: mockData.topBuyers[0].data.map(b => b.name),
                datasets: [{
                  label: "Total Spend (₹)",
                  data: mockData.topBuyers[0].data.map(b => b.spend),
                  backgroundColor: getChartColors(3).map(color => color + '80'),
                  borderColor: getChartColors(3),
                  borderWidth: 2
                }]
              }}
              options={{...chartOptions, indexAxis: 'y'}}
            />
          </div>
        </Card>
      </div>
    </div>
  );

  const tabs = [
    { id: 'overview', label: 'Overview', icon: '📊' },
    { id: 'participation', label: 'Participation', icon: '👥' },
    { id: 'cars', label: 'Car Metrics', icon: '🚗' },
    { id: 'bids', label: 'Bid Metrics', icon: '🔨' },
    { id: 'wins', label: 'Win Metrics', icon: '🏆' },
    { id: 'lenders', label: 'Lender Performance', icon: '🏢' }
  ];

  const renderTabContent = () => {
    switch (selectedTab) {
      case 'overview':
        return <OverviewTab />;
      case 'participation':
        return <ParticipationTab />;
      case 'wins':
        return <WinMetricsTab />;
      default:
        return <OverviewTab />;
    }
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={{margin: '0', fontSize: '2.5rem', fontWeight: '700'}}>
          Auction Analytics Dashboard
        </h1>
        <p style={{margin: '0.5rem 0 0 0', opacity: '0.9', fontSize: '1.1rem'}}>
          Real-time insights and performance metrics
        </p>
      </header>

      <nav style={styles.nav}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            style={{
              ...styles.navButton,
              ...(selectedTab === tab.id ? styles.activeNavButton : styles.inactiveNavButton)
            }}
            onClick={() => setSelectedTab(tab.id)}
          >
            <span style={{marginRight: '0.5rem'}}>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </nav>

      <main style={styles.content}>
        {renderTabContent()}
      </main>
    </div>
  );
};

export default Dashboard;